// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure FontAwesome loads from CDNJS if local files are missing */
@font-face {
  font-family: 'FontAwesome';
  src: url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.eot');
  src: url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'),
       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2') format('woff2'),
       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.woff') format('woff'),
       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf') format('truetype'),
       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.svg#fontawesomeregular') format('svg');
  font-weight: normal;
  font-style: normal;
}

/* Map missing custom icomoon/Glyphicons to FontAwesome so they display correctly */
[class^="icon-"], [class*=" icon-"] {
  font-family: 'FontAwesome' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Force FontAwesome font-family with higher specificity to prevent fonts.less override */
html [class^="icon-"], html [class*=" icon-"],
html [class^="icon-"]::before, html [class*=" icon-"]::before {
  font-family: 'FontAwesome' !important;
}

/* Specific mappings for key icomoon icons used in the app */
.icon-phone-down::before {
  content: '\\f095' !important; /* fa-phone */
  display: inline-block !important;
  transform: rotate(135deg) !important;
}
.icon-phone::before {
  content: '\\f095' !important; /* fa-phone */
}
.icon-left::before {
  content: '\\f104' !important; /* fa-angle-left */
}
.icon-screenshare::before {
  content: '\\f108'; /* fa-desktop */
}

/* ========================================================= */
/* CUSTOMER SCREENSHARE LAYOUT                               */
/* ========================================================= */

/* Container Setup when Screensharing is active */
#opentok-container.has-screenshare {
  display: flex !important;
  flex-direction: column;
  position: relative;
  background: #111 !important;
  overflow: hidden;
}

/* Picture-in-Picture logic for when a screenshare is active */
/* In UserVideo.js (Agent view), screenshare is published and remote video is viewed */
/* In EndkundeVideo.js (Customer view), screenshare is subscribed and local video is published */
#opentok-container.has-screenshare .OT_subscriber.OT_video-type-screen,
#opentok-container.has-screenshare .OT_publisher.OT_video-type-screen {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  z-index: 1 !important;
}

/* Base styles for all PiP cameras */
#opentok-container.has-screenshare .OT_publisher:not(.OT_video-type-screen),
#opentok-container.has-screenshare .OT_subscriber:not(.OT_video-type-screen) {
  position: absolute !important;
  top: auto !important;
  left: auto !important;
  bottom: 20px !important;
  width: 120px !important;
  height: 160px !important;
  z-index: 100 !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3) !important;
  border: 2px solid rgba(255,255,255,0.2) !important;
  transition: all 0.3s ease;
}

/* Offset the first PiP to the right */
#opentok-container.has-screenshare .OT_publisher:not(.OT_video-type-screen) {
  right: 20px !important;
}

/* Offset the second PiP to the left of the first one */
#opentok-container.has-screenshare .OT_subscriber:not(.OT_video-type-screen) {
  right: 160px !important;
}

/* Removed mobile split view override so PiP works universally on all devices */
.icon-right::before {
  content: '\\f105' !important; /* fa-angle-right */
}
.icon-phone-down2::before, .icon-call-end2::before {
  content: '\\f095' !important;
  display: inline-block !important;
  transform: rotate(135deg) !important;
}
.icon-camera::before {
  content: '\\f03d' !important; /* fa-video-camera */
}
.icon-camera-turn::before {
  content: '\\f021' !important; /* fa-refresh */
}
.icon-fullscreen::before, .icon-fullsreen2::before {
  content: '\\f065' !important; /* fa-expand */
}

/* Map missing Glyphicons to FontAwesome */
.glyphicon {
  font-family: 'FontAwesome' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.glyphicon-cog::before {
  content: '\\f013' !important; /* fa-cog */
}
.glyphicon-chevron-down::before {
  content: '\\f078' !important; /* fa-chevron-down */
}
.glyphicon-chevron-up::before {
  content: '\\f077' !important; /* fa-chevron-up */
}
.glyphicon-warning-sign::before {
  content: '\\f071' !important; /* fa-exclamation-triangle */
}
.glyphicon-ok-sign::before {
  content: '\\f058' !important; /* fa-check-circle */
}
.glyphicon-volume-off::before {
  content: '\\f026' !important; /* fa-volume-off */
}

/* CSS Theme Variables */
:root {
  /* Default: Dark Theme */
  --bg-color: #040814;
  --aurora-bg: radial-gradient(circle at 15% 40%, rgba(6, 182, 212, 0.12), transparent 45%), radial-gradient(circle at 85% 60%, rgba(38, 167, 223, 0.15), transparent 45%);
  --text-color: #f1f5f9;
  --text-muted: #a1b0c7; /* Improved contrast */
  --focus-ring: #60a5fa;
  
  --nav-bg: rgba(15, 23, 42, 0.9);
  --nav-text: #fff;
  --nav-brand-gradient: linear-gradient(135deg, #fff 50%, #60a5fa);
  
  --panel-bg: rgba(15, 23, 42, 0.4);
  --panel-border: rgba(255, 255, 255, 0.06);
  --panel-shadow: rgba(0, 0, 0, 0.25);
  
  --card-bg: rgba(30, 41, 59, 0.3);
  --card-border: rgba(255, 255, 255, 0.05);
  --card-text: rgba(38, 167, 223, 0.85);
  --card-text-hover: #26a7df;
  --card-text-active: #00c5ff;
  --card-bg-active: linear-gradient(135deg, rgba(38, 167, 223, 0.15) 0%, rgba(0, 197, 255, 0.15) 100%);
  --card-border-active: rgba(0, 197, 255, 0.3);
  --card-shadow-active: rgba(0, 197, 255, 0.15);
  
  --chat-bubble-out: linear-gradient(135deg, rgba(99, 102, 241, 0.16) 0%, rgba(139, 92, 246, 0.16) 100%);
  --chat-bubble-out-border: rgba(139, 92, 246, 0.25);
  --chat-bubble-in: rgba(30, 41, 59, 0.45);
  --chat-bubble-in-border: rgba(255, 255, 255, 0.05);
  
  --pill-bg: rgba(255, 255, 255, 0.03);
  --pill-border: rgba(255, 255, 255, 0.06);
  --pill-text: #94a3b8;
  
  --input-bg: rgba(0, 0, 0, 0.25);
  --input-border: rgba(255, 255, 255, 0.08);
  --input-text: #fff;
  
  --btn-default-bg: rgba(255, 255, 255, 0.04);
  --btn-default-border: rgba(255, 255, 255, 0.08);
  --btn-default-text: #cbd5e1;
  --btn-default-hover-bg: rgba(255, 255, 255, 0.08);
  --btn-default-hover-border: rgba(255, 255, 255, 0.15);
  
  --dropdown-bg: #1e293b;
  
  --scrollbar-track: #0d111a;
  --scrollbar-thumb: #1e293b;
  --scrollbar-thumb-hover: #0284c7;
  
  --video-backdrop: radial-gradient(circle at center, #1e293b 0%, #090d16 100%);
  --video-shadow: inset 0 0 100px rgba(0, 0, 0, 0.85);
  --glass-shadow: 0 25px 60px rgba(0, 0, 0, 0.5), 0 8px 20px rgba(0, 0, 0, 0.3);
  --overlay-bg: #0f172a;
}

/* Light Theme Variables overrides */
html[data-theme="light"] {
  --bg-color: #f1f5f9;
  --bg: #f1f5f9;
  --surface: #ffffff;
  --surface-2: #f1f5f9;
  --surface-3: #e2e8f0;
  --surface-color: var(--surface);
  --border: rgba(15, 23, 42, 0.08);
  --border-color: var(--border);
  --aurora-bg: radial-gradient(circle at 15% 40%, rgba(6, 182, 212, 0.06), transparent 45%), radial-gradient(circle at 85% 60%, rgba(38, 167, 223, 0.06), transparent 45%);
  --text-color: #1e293b;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #475569; 
  --focus-ring: #0284c7;
  
  --nav-bg: #ffffff;
  --nav-text: #1e293b;
  --nav-brand-gradient: linear-gradient(135deg, #1e293b 50%, #0284c7);
  
  --panel-bg: #ffffff;
  --panel-border: rgba(15, 23, 42, 0.06);
  --panel-shadow: rgba(15, 23, 42, 0.08);
  
  --card-bg: rgba(255, 255, 255, 0.5);
  --card-border: rgba(15, 23, 42, 0.05);
  --card-text: rgba(2, 132, 199, 0.9);
  --card-text-hover: #0284c7;
  --card-text-active: #0369a1;
  --card-bg-active: linear-gradient(135deg, rgba(2, 132, 199, 0.1) 0%, rgba(14, 165, 233, 0.1) 100%);
  --card-border-active: rgba(2, 132, 199, 0.25);
  --card-shadow-active: rgba(2, 132, 199, 0.15);
  
  --chat-bubble-out: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%);
  --chat-bubble-out-border: rgba(139, 92, 246, 0.15);
  --chat-bubble-in: rgba(255, 255, 255, 0.75);
  --chat-bubble-in-border: rgba(15, 23, 42, 0.06);
  
  --pill-bg: rgba(15, 23, 42, 0.04);
  --pill-border: rgba(15, 23, 42, 0.08);
  --pill-text: #475569;
  
  --input-bg: rgba(255, 255, 255, 0.75);
  --input-border: rgba(15, 23, 42, 0.1);
  --input-text: #1e293b;
  
  --btn-default-bg: rgba(255, 255, 255, 0.6);
  --btn-default-border: rgba(15, 23, 42, 0.1);
  --btn-default-text: #334155;
  --btn-default-hover-bg: rgba(255, 255, 255, 0.9);
  --btn-default-hover-border: rgba(15, 23, 42, 0.2);
  
  --dropdown-bg: rgba(255, 255, 255, 0.95);
  
  --scrollbar-track: rgba(241, 245, 249, 0.5);
  --scrollbar-thumb: #cbd5e1;
  --scrollbar-thumb-hover: #94a3b8;
  
  --video-backdrop: radial-gradient(circle at 15% 40%, rgba(14, 165, 233, 0.15) 0%, transparent 50%), radial-gradient(circle at 85% 60%, rgba(99, 102, 241, 0.15) 0%, transparent 50%), #eef2f6;
  --video-shadow: inset 0 0 60px rgba(15, 23, 42, 0.05);
  --video-text-shadow: 0 2px 10px rgba(255, 255, 255, 0.5);
  --glass-shadow: 0 25px 60px rgba(15, 23, 42, 0.12), 0 8px 20px rgba(15, 23, 42, 0.06);
  --overlay-bg: #ffffff;
}

/* Base Styles & Full-screen Reset overrides */
body, html {
  background-color: var(--bg-color) !important;
  background-image: var(--aurora-bg) !important;
  background-attachment: fixed !important;
  color: var(--text-color) !important;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
  height: 100vh !important;
  width: 100vw !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow-x: hidden !important;
  overflow-y: auto !important; /* Allow vertical scrolling for long pages (e.g. Terms of Service, pre-call check) */
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Global Focus Styles for Accessibility */
*:focus-visible {
  outline: 2px solid var(--focus-ring) !important;
  outline-offset: 2px !important;
}

*:focus:not(:focus-visible) {
  outline: none !important;
}

#app, .portrait, .navigation {
  min-height: 100vh !important;
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}
::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--scrollbar-thumb-hover);
}

/* Floating Glassmorphic Navbar (Header) */
.navbar-default {
  flex: 0 0 auto !important;
  background: var(--nav-bg) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-bottom: 1px solid var(--panel-border) !important;
  box-shadow: 0 4px 20px var(--panel-shadow) !important;
  margin-bottom: 0 !important;
  padding: 10px 0 !important;
  z-index: 100 !important;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.navbar-default .navbar-brand {
  font-weight: 700 !important;
  color: var(--nav-text) !important;
  letter-spacing: -0.5px;
  display: inline-flex !important;
  align-items: center;
  gap: 8px;
  background: var(--nav-brand-gradient) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.breadcrumb-menu li a {
  color: var(--text-muted) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  transition: color 0.25s ease !important;
}

.breadcrumb-menu li a:hover {
  color: #3b82f6 !important;
  text-decoration: none !important;
}

.breadcrumb-menu li + li:before {
  color: var(--panel-border) !important;
}

.user-menu li span {
  color: var(--text-color) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.user-menu li a {
  color: var(--text-muted) !important;
  font-weight: 500 !important;
  transition: color 0.25s ease !important;
}

.user-menu li a:hover {
  color: #3b82f6 !important;
  text-decoration: none !important;
}

/* Dashboard Container filling remaining space */
.content-bg {
  flex: 1 1 auto !important;
  width: 100% !important;
  max-width: 100% !important;
  height: calc(100vh - 70px) !important;
  margin: 0 !important;
  padding: 16px !important;
  background: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  transition: background-color 0.3s ease;
}

/* ============================================================
   GRID LAYOUT — Dashboard
   ─────────────────────────────────────────────────────────
   Actual React DOM (after this CSS):

   .customer-single (Flex column)
     NavBarConfig
     .layout-3-col   (CSS Grid container, flex: 1)
       .layout-left     → grid-area: sidebar    (order list)
       .layout-center   → grid-area: center     (flex column)
         .video-chat-header   (flex-shrink:0)
         .layout-video-area   (flex:1 — video fills space)
         .chat-input          (flex-shrink:0 — pinned bottom)
       .layout-right.inner-middle → grid-area: timeline (flex column, events)
   ============================================================ */

.customer-single {
  display: flex !important;
  flex-direction: column !important;
  height: 100vh !important;
  width: 100vw !important;
  overflow: hidden !important;
}

/* The grid itself now applied to the wrapper that contains exactly 3 columns */
.layout-3-col {
  display: grid !important;
  grid-template-columns: 230px 1fr 300px !important;
  grid-template-rows: 1fr !important;
  grid-template-areas: "sidebar center timeline" !important;
  gap: 10px !important;
  flex: 1 1 auto !important;
  width: 100% !important;
  min-height: 0 !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
  padding: 10px !important;
}

.middle {
  display: contents !important;
}

/* ── 1. LEFT: Sidebar ───────────────────────────────────── */
.layout-left {
  grid-area: sidebar !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0 !important;
  min-width: 0 !important;
}

.order-sidebar {
  flex: 1 1 auto !important;
  background: var(--panel-bg) !important;
  border: 1px solid var(--panel-border) !important;
  border-radius: 16px !important;
  padding: 16px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  min-height: 0 !important;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.order-sidebar h4 {
  font-weight: 700 !important;
  color: var(--text-color) !important;
  font-size: 12px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 12px 0 !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 0 0 auto !important;
}

.order-sidebar h4 small {
  font-size: 11px !important;
  text-transform: none;
  color: var(--card-text-hover) !important;
  cursor: pointer;
}

.order-sidebar-toggle, .order-header-mobile {
  display: none !important;
}

.orders {
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-height: 0;
}

.order-sidebar .order {
  display: flex !important;
  width: 100% !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  box-shadow: none !important;
  flex: 0 0 auto !important;
}

.order-sidebar .order a {
  text-decoration: none !important;
  display: block !important;
  width: 100% !important;
}

.order-sidebar .order .text {
  background: var(--card-bg) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 8px !important;
  padding: 7px 10px !important;
  font-size: 13px !important;
  color: var(--card-text) !important;
  cursor: pointer !important;
  width: 100% !important;
  display: flex !important;
  align-items: center !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box !important;
  text-decoration: none !important;
}

.order-sidebar .order:hover .text {
  background: var(--btn-default-hover-bg) !important;
  border-color: var(--card-text-hover) !important;
  color: var(--card-text-hover) !important;
  transform: translateX(2px) !important;
}

.order-sidebar .order.active {
  background: var(--card-bg-active) !important;
  border-color: var(--card-border-active) !important;
  color: var(--text-color) !important;
}

.order-sidebar .order.active .text {
  background: transparent !important;
  border-color: transparent !important;
  color: var(--text-color) !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.order-sidebar .order a:hover .text, .order-sidebar .order a:hover {
  color: var(--card-text-hover) !important;
  text-decoration: none !important;
}

.order-sidebar .order.active a, .order-sidebar .order.active a .text {
  color: var(--card-text-active) !important;
  text-decoration: none !important;
}

.order.finished .fa-check {
  color: #10b981 !important;
  margin-left: auto;
}

/* Project Hover Actions */
.hover-parent .hover-actions-menu {
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  background: inherit;
  padding-left: 8px;
}

.hover-parent:hover .hover-actions-menu {
  opacity: 1;
}

.hover-actions-menu .action-icon {
  font-size: 13px;
  color: var(--text-muted);
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.hover-actions-menu .action-icon:hover {
  color: var(--text-color);
  background: rgba(0, 0, 0, 0.05);
}



.new-order {
  flex: 0 0 auto !important;
  background: var(--input-bg) !important;
  border: 1px solid var(--input-border) !important;
  border-radius: 8px !important;
  color: var(--input-text) !important;
  font-size: 13px !important;
  padding: 8px 12px !important;
  margin-top: 12px !important;
  width: 100% !important;
  transition: all 0.2s ease !important;
  box-sizing: border-box;
}

.new-order:focus {
  border-color: var(--card-text-active) !important;
  box-shadow: 0 0 10px var(--card-shadow-active) !important;
  outline: none !important;
}

/* ── 2. CENTER: Header + Video + Note Input ─────────────── */
.layout-center {
  grid-area: center !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 10px !important;
  min-height: 0 !important;
  min-width: 0 !important;
  overflow: hidden !important;
  padding-bottom: 24px;
}

/* Modern Initials / Avatar Styling */
.avatar {
  background: rgba(59, 130, 246, 0.15) !important;
  color: #3b82f6 !important;
  border: none !important;
  font-weight: 700 !important;
  font-size: 20px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.1) !important;
  transition: all 0.3s ease !important;
}

/* Customer header bar */
.video-chat-header {
  flex: 0 0 auto !important;
  background: var(--panel-bg) !important;
  border: 1px solid var(--panel-border) !important;
  border-radius: 14px !important;
  padding: 8px 16px !important; /* reduced from 12px 18px */
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  box-sizing: border-box !important;
  min-width: 0 !important;
  transition: background-color 0.3s ease;
}

.video-chat-header .customer-sub-title {
  font-size: 20px !important;
  font-weight: 700 !important;
  color: var(--text-color) !important;
  margin-bottom: 2px !important;
}

/* Video wrapper — fills all available vertical space */
.layout-video-area {
  flex: 1 1 0 !important;
  min-height: 0 !important;
  max-height: calc(100vh - 290px); /* navbar ~50px + header ~60px + ChatInput ~60px + gaps ~80px + padding ~40px */
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.layout-video-area .video-status-container,
.layout-video-area > * {
  flex: 1 1 0 !important;
  min-height: 0 !important;
}

.video-status-container {
  background: var(--video-backdrop) !important;
  border: 1px solid var(--panel-border) !important;
  border-radius: 18px !important;
  width: 100% !important;
  flex: 1 1 0 !important;   /* fills parent, but never pushes siblings out */
  min-height: 0 !important;
  min-width: 0 !important;
  box-shadow: var(--video-shadow) !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  position: relative !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
  transition: border-color 0.3s ease;
}

.video-status-container::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(45deg, rgba(59, 130, 246, 0.03) 0%, rgba(139, 92, 246, 0.03) 100%);
  z-index: 1;
}

.video-status-container .video-status-message {
  background-color: transparent !important;
  max-width: 75% !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: var(--text-color) !important;
  text-shadow: var(--video-text-shadow, 0 4px 12px rgba(0, 0, 0, 0.7)) !important;
  z-index: 2 !important;
  text-align: center !important;
  line-height: 1.5 !important;
  animation: floatPulse 3s ease-in-out infinite !important;
  padding: 0 !important;
  box-shadow: none !important;
  border: none !important;
}

/* Note / chat input — pinned at bottom of center column */
.chat-input {
  flex: 0 0 auto !important;
  background: var(--panel-bg) !important;
  border: 1px solid var(--panel-border) !important;
  border-radius: 14px !important;
  padding: 10px 14px !important;
  box-sizing: border-box !important;
  width: 100% !important;
  min-width: 0 !important;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.chat-input form { margin: 0 !important; width: 100% !important; }

.chat-input .input-group {
  width: 100% !important;
  display: flex !important;
  gap: 8px !important;
  align-items: center !important;
}

.chat-input .form-control {
  background: var(--input-bg) !important;
  border: 1px solid var(--input-border) !important;
  border-radius: 8px !important;
  color: var(--input-text) !important;
  font-size: 13px !important;
  padding: 8px 12px !important;
  height: 38px !important;
  flex: 1 1 auto !important;
  box-sizing: border-box !important;
  transition: all 0.2s ease !important;
}

.chat-input .form-control:focus {
  border-color: var(--card-text-active) !important;
  box-shadow: 0 0 10px var(--card-shadow-active) !important;
  outline: none !important;
}

.chat-input .input-group-btn { flex: 0 0 auto !important; }

.lh-btn {
  border-radius: 8px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.2px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  font-size: 14px !important;
}

.lh-btn-small, .lh-btn-extra-small {
  padding: 8px 16px !important;
  font-size: 13px !important;
  border-radius: 6px !important;
}

.lh-btn-default {
  background: var(--btn-default-bg) !important;
  color: var(--text-color) !important;
  border: 1px solid var(--btn-default-border) !important;
  transition: all 0.2s ease !important;
}

.lh-btn-default:hover {
  background: var(--btn-default-hover-bg) !important;
  border-color: var(--btn-default-hover-border) !important;
}

.lh-btn-primary {
  background: linear-gradient(135deg, #0284c7 0%, #2563eb 100%) !important;
  color: #fff !important;
  box-shadow: 0 4px 14px rgba(2, 132, 199, 0.3) !important;
  border: none !important;
}

.lh-btn-primary:hover {
  background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;
  box-shadow: 0 5px 16px rgba(37, 99, 235, 0.5) !important;
  transform: translateY(-1px) !important;
}

.chat-input .btn-default {
  background: linear-gradient(135deg, #0284c7 0%, #2563eb 100%) !important;
  color: #fff !important;
  border: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  border-radius: 8px !important;
  padding: 0 14px !important;
  height: 38px !important;
  box-shadow: 0 3px 10px rgba(2, 132, 199, 0.3) !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
  white-space: nowrap !important;
}

.chat-input .btn-default:hover {
  background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 5px 16px rgba(37, 99, 235, 0.5) !important;
}

/* ── 3. RIGHT: Event Timeline ───────────────────────────── */
.inner-middle {
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  min-height: 0 !important;
  min-width: 0 !important;
  box-sizing: border-box !important;
  background: var(--panel-bg) !important;
  border: 1px solid var(--panel-border) !important;
  border-radius: 16px !important;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.order-header {
  flex: 0 0 auto !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid var(--panel-border) !important;
}

.event-items {
  flex: 1 1 auto !important;
  overflow-y: auto !important;
  min-height: 0 !important;
  padding: 10px 8px !important;
  display: flex !important;
  flex-direction: column-reverse !important;
  gap: 6px !important;
  box-sizing: border-box !important;
}

/* Timeline title */
.inner-middle > h5,
.inner-middle > .timeline-title {
  flex: 0 0 auto !important;
  padding: 14px 16px 10px !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  color: var(--text-muted) !important;
  border-bottom: 1px solid var(--panel-border) !important;
  margin: 0 !important;
}

/* ─── Animations ────────────────────────────────────────────────────────────  */

@keyframes floatPulse {
  0%   { transform: translateY(0);   opacity: 0.85; }
  50%  { transform: translateY(-4px); opacity: 1; }
  100% { transform: translateY(0);   opacity: 0.85; }
}

/* ─── Print ──────────────────────────────────────────────────────────────── */

@media print {
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  body, html, #app { background-color: var(--bg-color) !important; height: auto !important; overflow: visible !important; }
  .content-bg { height: auto !important; overflow: visible !important; }
  .customer-single { display: block !important; height: auto !important; }
  .order-sidebar { display: none !important; }
  .video-status-container { height: 400px !important; margin-bottom: 24px !important; }
  .video-status-toolbar { display: none !important; }
  .inner-middle { height: auto !important; overflow: visible !important; background: transparent !important; border: none !important; }
  .event-items { height: auto !important; overflow: visible !important; }
  .call { page-break-inside: avoid; break-inside: avoid; }
}


/* ───────────────────────────────────────────────────────────── */
/* RESPONSIVE CUSTOMER DASHBOARD GRID (Video-Stream)             */
/* ───────────────────────────────────────────────────────────── */

.customer-dashboard-grid {
  display: grid;
  flex: 1 1 auto;
  height: 100% !important;
  overflow: hidden;
  min-height: 0;
  gap: 16px;
  padding: 0;
  box-sizing: border-box;
  position: relative;
}

/* Default Desktop Layout */
@media (min-width: 1101px) {
  .customer-dashboard-grid {
    grid-template-columns: 220px minmax(0, 1fr) 300px;
    grid-template-rows: minmax(0, 1fr);
  }

  .customer-dashboard-grid.sidebar-closed {
    grid-template-columns: minmax(0, 1fr) 300px;
  }

  .customer-dashboard-grid.sidebar-closed .customer-left-column {
    display: none !important;
  }
}

/* Base styles for columns */
.customer-left-column,
.customer-center-column,
.customer-right-column {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  min-width: 0;
}

.customer-left-column .order-sidebar {
  border-radius: 0 !important;
  border-top: none !important;
  border-left: none !important;
  border-bottom: none !important;
  border-right: 1px solid var(--panel-border) !important;
  height: 100% !important;
}

.customer-center-column {
  width: 100%;
  gap: 8px; /* reduced from 16px to save vertical space */
  padding: 16px 0;
}

.customer-right-column {
  background: var(--panel-bg);
  border-radius: 16px;
  border: 1px solid var(--panel-border);
  margin: 16px 16px 16px 0;
}

/* Desktop with active call: Hide Left Column (REMOVED: the user requested to always see it) */
/* .customer-dashboard-grid.has-active-call { grid-template-columns: minmax(0, 1fr) 300px; } */
/* .customer-dashboard-grid.has-active-call .customer-left-column { display: none; } */

/* Tablets & Mobile (screen <= 1100px) - Full Height Video Layout */
@media (max-width: 1100px) {
  .customer-dashboard-grid {
    display: flex !important;
    flex-direction: column !important;
    height: 100% !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    gap: 0 !important;
    overflow: hidden !important;
    position: relative !important;
  }
  .customer-center-column {
    flex: 1 1 auto !important;
    height: 100% !important;
    width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    gap: 0 !important;
    min-height: 0 !important;
    position: relative !important;
  }
  .customer-center-column .layout-video-area {
    flex: 1 1 auto !important;
    height: 100% !important;
    width: 100% !important;
    border-radius: 0 !important;
    min-height: 0 !important;
    min-width: 0 !important;
  }
  .customer-right-column.desktop-only,
  .desktop-chat-input {
    display: none !important;
  }
  .customer-left-column {
    display: none;
  }
  .customer-left-column.active {
    display: flex !important;
    position: absolute !important;
    top: 0 !important;
    left: 0;
    width: 220px !important;
    height: 100% !important;
    z-index: 1000 !important;
    background: var(--overlay-bg) !important;
    padding: 0 !important;
    box-sizing: border-box;
    margin: 0 !important;
    border-right: 1px solid var(--panel-border) !important;
    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15) !important;
  }
  .customer-left-column.active .order-sidebar {
    display: flex !important;
    flex: 1 1 auto !important;
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
    border: none !important;
    box-shadow: none !important;
    padding-top: 16px !important;
  }

  /* Full container sizing for video on mobile */
  .videomode,
  .video-chat-embedded,
  .videomode .video-wrapper,
  .videomode .video-box.embedded,
  .videomode #opentok-container,
  .video-chat-embedded #opentok-container {
    width: 100% !important;
    height: 100% !important;
    max-width: 100% !important;
    max-height: 100% !important;
    border-radius: 0 !important;
  }
}

@media (max-width: 992px) {
  .sidebar-container {
    background-color: var(--overlay-bg) !important;
  }
}

/* Project Sidebar Redesign */
.all-events-link {
  text-decoration: none;
}

.new-order-top {
  margin-bottom: 15px;
}

.project-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 15px;
}

.project-card-link {
  text-decoration: none;
  display: block;
}

.project-card {
  background: white;
  border-radius: 6px;
  padding: 12px 15px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}
.project-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0,0,0,0.08);
  border-color: #d0d7de;
}
.project-card.active {
  border-color: #007bff;
  box-shadow: 0 0 0 1px #007bff;
}
.project-card .text {
  display: flex;
  align-items: center;
  width: 100%;
}
.project-icon {
  margin-right: 10px;
  color: #6c757d;
  font-size: 1.2em;
}
/* Removed .project-card.active .project-icon color override so inline styles work */
.project-name {
  flex-grow: 1;
  color: #333;
  font-weight: 500;
}
.check-icon {
  color: #28a745;
  margin-left: 10px;
}

/* ========================================================= */
/* AGENT VIDEO VIEW REDESIGN (CustomerSinglePage)            */
/* ========================================================= */

/* 1. Modernisierung des Video-Containers */
.videomode.video-chat-embedded {
  position: relative;
  background-color: transparent !important;
  border-radius: 18px !important;
  overflow: hidden;
  box-shadow: none !important;
  display: flex !important;
  flex: 1 1 auto !important;
  flex-direction: column !important;
  height: 100% !important;
  min-height: 400px !important;
}

.videomode .video-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 18px;
  overflow: hidden;
  background: transparent;
}

/* Fix: .video div (the direct child of .publisher-video-screen) must fill parent.
 * Must be position:relative (not absolute) so its bounding rect correctly reflects
 * the actual video area for tele-point (touch marker) coordinate calculations. */
.publisher-video-screen .video,
.publisher-video-screen .videomode {
  position: relative !important;
  width: 100% !important;
  height: 100% !important;
}

/* Ensure the opentok container takes full space */
.videomode #opentok-container {
  width: 100% !important;
  height: 100% !important;
  background-color: #000 !important;
}

/* 2. Floating Toolbar (Tools.js) - Compact & Elegant */
.videomode .tools,
.publisher-video-screen .tools {
  position: absolute !important;
  bottom: 12px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 100;
  background: rgba(255, 255, 255, 0.25) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.6) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.6) !important;
  backdrop-filter: blur(12px) saturate(150%) !important;
  -webkit-backdrop-filter: blur(12px) saturate(150%) !important;
  border-radius: 40px !important; /* Elegant pill shape */
  padding: 6px 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15), inset 0 0 0 1px rgba(255, 255, 255, 0.1) !important;
  display: flex !important;
  justify-content: center;
  align-items: center;
  width: max-content !important;
  max-width: 96vw !important;
  min-width: 0 !important;
}

/* For very small mobile screens */
@media (max-width: 400px) {
  .videomode .tools,
  .publisher-video-screen .tools {
    max-width: 98vw !important;
    padding: 4px 8px !important;
  }
}

.videomode .tools .middle,
.publisher-video-screen .tools .middle {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important; /* Never wrap to multiple rows */
  gap: 10px !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Landscape Orientation: Pin toolbar to the right side, stacked vertically */
@media (orientation: landscape) and (min-width: 900px) {
  .videomode .tools,
  .publisher-video-screen .tools {
    bottom: 50% !important;
    left: auto !important;
    right: 16px !important;
    transform: translateY(50%) !important;
    padding: 12px 6px !important;
    max-height: 90vh !important;
    max-width: max-content !important;
  }
  .videomode .tools .middle,
  .publisher-video-screen .tools .middle {
    flex-direction: column !important;
  }
}

/* 3. Button-Zustände */
.videomode .tools .button,
.publisher-video-screen .tools .button {
  width: 46px !important;
  height: 46px !important;
  border-radius: 50% !important;
  background: rgba(0, 0, 0, 0.05) !important;
  color: #1e293b !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;
}

.videomode .tools .button i,
.publisher-video-screen .tools .button i {
  font-size: 20px !important;
}

.videomode .tools .button:hover,
.publisher-video-screen .tools .button:hover {
  background: rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;
}

.videomode .tools .button:active,
.publisher-video-screen .tools .button:active {
  transform: translateY(1px) !important;
}

/* Mobile specific toolbar sizing */
@media (max-width: 768px) {
  .videomode .tools,
  .publisher-video-screen .tools {
    bottom: 10px !important;
    padding: 5px 10px !important;
  }
  .videomode .tools .middle,
  .publisher-video-screen .tools .middle {
    gap: 8px !important;
  }
  .videomode .tools .button,
  .publisher-video-screen .tools .button {
    width: 40px !important;
    height: 40px !important;
  }
  .videomode .tools .button i,
  .publisher-video-screen .tools .button i {
    font-size: 17px !important;
  }
}

/* STATUS MUTED / INACTIVE */
.videomode .tools .button.status-muted,
.publisher-video-screen .tools .button.status-muted {
  background: rgba(239, 68, 68, 0.15) !important;
  color: #dc2626 !important;
  border: 1px solid rgba(239, 68, 68, 0.2) !important;
}
.videomode .tools .button.status-muted:hover,
.publisher-video-screen .tools .button.status-muted:hover {
  background: rgba(239, 68, 68, 0.25) !important;
}

/* ACTIVE / SELECTED STATES (e.g. Draw Mode, Screen Share, Notes) */
.videomode .tools .button.active,
.publisher-video-screen .tools .button.active,
.videomode .tools .button.btn-notes.active {
  background: rgba(14, 165, 233, 0.15) !important;
  color: #0284c7 !important;
  border: 1px solid rgba(14, 165, 233, 0.3) !important;
}

/* END CALL BUTTON (Prominentes Rot) */
.videomode .tools .button.btn-end-call,
.publisher-video-screen .tools .button.btn-end-call {
  background: #ef4444 !important;
  color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;
}
.videomode .tools .button.btn-end-call:hover,
.publisher-video-screen .tools .button.btn-end-call:hover {
  background: #dc2626 !important;
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;
  transform: translateY(-2px) scale(1.05) !important;
}

/* ───────────────────────────────────────────────────────────── */
/* MOBILE NOTES & ACTIVITIES OVERLAY / DRAWER                    */
/* ───────────────────────────────────────────────────────────── */

.mobile-notes-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.mobile-notes-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.mobile-notes-panel {
  position: relative;
  z-index: 2001;
  width: 100%;
  max-height: 80vh;
  height: 75vh;
  background: var(--panel-bg, #1e293b);
  border-top: 1px solid var(--panel-border, #334155);
  border-radius: 20px 20px 0 0;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  box-sizing: border-box;
}

.mobile-notes-overlay.open {
  pointer-events: auto;
}

.mobile-notes-overlay.open .mobile-notes-backdrop {
  opacity: 1;
  pointer-events: auto;
}

.mobile-notes-overlay.open .mobile-notes-panel {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

.mobile-notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid var(--panel-border, #334155);
  flex-shrink: 0;
}

.mobile-notes-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-color, #f8fafc);
  display: flex;
  align-items: center;
}

.mobile-notes-close-btn {
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-muted, #94a3b8);
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-notes-close-btn:hover {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
}

.mobile-notes-input-wrapper {
  padding: 12px 16px;
  border-bottom: 1px solid var(--panel-border, #334155);
  background: rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.mobile-notes-timeline-wrapper {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 16px;
  min-height: 0;
  -webkit-overflow-scrolling: touch;
}

/* Floating Action Button (FAB) for mobile when outside of active call */
.mobile-notes-toggle-fab {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: var(--primary-color, #0284c7);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 1040;
  transition: all 0.2s ease;
}

.mobile-notes-toggle-fab:active {
  transform: scale(0.95);
}

@media (min-width: 1101px) {
  .mobile-notes-overlay,
  .mobile-notes-toggle-fab {
    display: none !important;
  }
}

/* 4. Status-Meldungen & Overlays - Always at the top of the video screen, highly visible and high contrast */
.videomode .video-overlay,
.publisher-video-screen .video-overlay {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
  transform: none !important;
  background: rgba(15, 23, 42, 0.92) !important;
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  color: #fff !important;
  padding: 12px 24px !important;
  border-radius: 0 !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-align: center !important;
  box-shadow: 0 4px 20px rgba(0,0,0,0.4) !important;
  z-index: 99999 !important;
  white-space: normal !important; /* Allow wrapping if text is long on mobile */
  pointer-events: none !important;
}


/* ========================================================= */
/* GLOBAL THEME & ACCESSIBILITY STYLES (NO THEME-DARK REQ)   */
/* ========================================================= */

body, #app {
  background-color: var(--bg-color) !important;
  background-image: var(--aurora-bg) !important;
  background-attachment: fixed !important;
  color: var(--text-color) !important;
  transition: background-color 0.4s ease, color 0.4s ease, background-image 0.4s ease !important;
}

/* Typography transitions */
h1, h2, h3, h4, h5, h6, p, span, div, a {
  transition: color 0.4s ease, background-color 0.4s ease;
}

/* Forms Accessibility & Theme */
input, textarea, select, .form-control {
  background-color: var(--input-bg) !important;
  border: 1px solid var(--input-border) !important;
  color: var(--input-text) !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;
}

input:focus, textarea:focus, select:focus, .form-control:focus {
  outline: none !important;
  border-color: var(--focus-ring) !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2) !important;
}

/* Glassmorphism for Panels */
.panel, .card, .video-box, .box, .list-group-item, .well {
  background: var(--panel-bg) !important;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--panel-border) !important;
  box-shadow: 0 8px 32px var(--panel-shadow) !important;
  transition: background-color 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease !important;
}

/* Navbar transparency */
.navbar {
  background: var(--nav-bg) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--panel-border) !important;
  transition: background-color 0.4s ease, border-color 0.4s ease !important;
}

/* Micro-interactions & Gradients for Buttons */
.btn-primary, .btn-info {
  background: linear-gradient(135deg, #06b6d4, #26a7df) !important;
  border: none !important;
  color: white !important;
  box-shadow: 0 4px 10px rgba(38, 167, 223, 0.2) !important;
  transition: all 0.3s ease !important;
}

.btn-primary:hover, .btn-info:hover {
  background: linear-gradient(135deg, #0ea5e9, #38bdf8) !important;
  box-shadow: 0 6px 15px rgba(38, 167, 223, 0.4) !important;
  transform: translateY(-1px);
}

.btn-primary:active, .btn-info:active {
  transform: translateY(1px);
  box-shadow: 0 2px 5px rgba(38, 167, 223, 0.2) !important;
}

.new-order-top {
  margin-left: 0 !important;
  margin-right: 0 !important;
  width: 100% !important;
}

/* Mobile Sidebar & Accessibility Styles */
.order-sidebar-toggle-btn {
  display: none; /* hidden by default on desktop */
  background: none;
  border: 1px solid var(--panel-border);
  border-radius: 8px;
  color: var(--text-color);
  padding: 6px 10px;
  cursor: pointer;
  font-size: 16px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}


.order-sidebar-mobile-close {
  display: none;
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  color: var(--text-color);
  background: none;
  border: none;
  cursor: pointer;
  z-index: 10000;
}



/* Resizer */
.column-resizer:hover {
  background-color: rgba(100, 100, 100, 0.2);
}
.column-resizer:active {
  background-color: rgba(100, 100, 100, 0.4);
}

/* Info Tooltip */
.info-tooltip {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  border: none;
  font-size: 11px;
  font-weight: bold;
  cursor: help;
  margin-left: 8px;
  vertical-align: middle;
}

.info-tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(4px);
  background: var(--primary-color);
  color: white;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: normal;
  white-space: normal;
  width: max-content;
  max-width: 300px;
  text-align: left; /* Bei längeren Texten liest sich linksbündig besser */
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, transform 0.2s;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.info-tooltip::before {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateY(-2px);
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent var(--primary-color) transparent;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, transform 0.2s;
  pointer-events: none;
  z-index: 9999;
}

.info-tooltip:hover::after,
.info-tooltip:hover::before {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(8px);
}
.info-tooltip:hover::before {
  transform: translateX(-50%) translateY(2px);
}

/* ---------------------------------------------------
 * Offline/Online Badge Modernization
 * --------------------------------------------------- */
.offline-ui {
  position: absolute !important;
  bottom: 24px !important;
  left: 24px !important;
  top: auto !important;
  right: auto !important;
  z-index: 100 !important;
  border-radius: var(--radius-pill) !important;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.1px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 4px !important;
  padding: 7px 14px !important;
  cursor: default !important;
  transition: box-shadow 0.3s ease, background 0.3s ease !important;
}

/* Dark mode (default): Apple Liquid Glass */
.offline-ui {
  background: rgba(15, 23, 42, 0.35) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #f1f5f9 !important;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.06),
    0 0 18px 4px rgba(255,255,255,0.08),
    0 8px 24px rgba(0,0,0,0.3) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
}
.offline-ui.offline-ui-up {
  box-shadow:
    0 0 0 1px rgba(74, 222, 128, 0.2),
    0 0 22px 6px rgba(74, 222, 128, 0.25),
    0 4px 12px rgba(0,0,0,0.4) !important;
}
.offline-ui.offline-ui-down {
  box-shadow:
    0 0 0 1px rgba(239, 68, 68, 0.25),
    0 0 22px 6px rgba(239, 68, 68, 0.3),
    0 4px 12px rgba(0,0,0,0.4) !important;
}

/* Hide legacy dot and fix spacing */
.offline-ui-content::after {
  display: none !important;
}
.offline-ui-content {
  padding-left: 0 !important;
}

/* Dot indicator */
.offline-indicator-dot {
  display: inline-block !important;
  width: 8px !important;
  height: 8px !important;
  border-radius: 50% !important;
  flex-shrink: 0 !important;
}
.offline-ui-up .offline-indicator-dot {
  background: #4ade80 !important;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.8) !important;
  animation: pulse-green 2s infinite !important;
}
.offline-ui-down .offline-indicator-dot {
  background: #ef4444 !important;
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.8) !important;
}

@keyframes pulse-green {
  0%, 100% { box-shadow: 0 0 4px rgba(74, 222, 128, 0.6); }
  50%       { box-shadow: 0 0 12px rgba(74, 222, 128, 1); }
}

/* Light mode: Apple Liquid Glass */
html[data-theme="light"] .offline-ui {
  background: rgba(255, 255, 255, 0.25) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.6) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.6) !important;
  color: #1e293b !important;
  box-shadow:
    0 8px 32px rgba(0, 0, 0, 0.15),
    inset 0 0 0 1px rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(12px) saturate(150%) !important;
  -webkit-backdrop-filter: blur(12px) saturate(150%) !important;
}
html[data-theme="light"] .offline-ui.offline-ui-up {
  box-shadow:
    0 0 0 1px rgba(21, 128, 61, 0.2),
    0 0 20px 5px rgba(21, 128, 61, 0.2),
    0 4px 12px rgba(15,23,42,0.12) !important;
}
html[data-theme="light"] .offline-ui.offline-ui-down {
  box-shadow:
    0 0 0 1px rgba(185, 28, 28, 0.2),
    0 0 20px 5px rgba(185, 28, 28, 0.2),
    0 4px 12px rgba(15,23,42,0.12) !important;
}
html[data-theme="light"] .offline-ui.offline-ui-up::before {
  background: #16a34a !important;
  box-shadow: 0 0 6px rgba(21, 128, 61, 0.7) !important;
}

/* ---------------------------------------------------
 * Publisher Video Screen: always dark background
 * regardless of light/dark mode (you're in a video call!)
 * --------------------------------------------------- */
.publisher-video-screen,
.publisher-video-screen .video,
.publisher-video-screen .videomode {
  background: #000 !important;
}

/* Always use dark mode style for offline/online badges on video screens */
.publisher-video-screen .offline-ui,
.videomode .offline-ui,
html[data-theme="light"] .publisher-video-screen .offline-ui,
html[data-theme="light"] .videomode .offline-ui {
  background: rgba(15, 23, 42, 0.45) !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  border-top: 1px solid rgba(255, 255, 255, 0.25) !important;
  color: #f8fafc !important;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.06),
    0 0 18px 4px rgba(255,255,255,0.08),
    0 8px 24px rgba(0,0,0,0.3) !important;
  backdrop-filter: blur(20px) saturate(180%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;
}

.publisher-video-screen .offline-ui.offline-ui-up,
.videomode .offline-ui.offline-ui-up,
html[data-theme="light"] .publisher-video-screen .offline-ui.offline-ui-up,
html[data-theme="light"] .videomode .offline-ui.offline-ui-up {
  box-shadow:
    0 0 0 1px rgba(74, 222, 128, 0.2),
    0 0 22px 6px rgba(74, 222, 128, 0.25),
    0 10px 30px rgba(0,0,0,0.45) !important;
}

.publisher-video-screen .offline-ui.offline-ui-down,
.videomode .offline-ui.offline-ui-down,
html[data-theme="light"] .publisher-video-screen .offline-ui.offline-ui-down,
html[data-theme="light"] .videomode .offline-ui.offline-ui-down {
  box-shadow:
    0 0 0 1px rgba(239, 68, 68, 0.25),
    0 0 22px 6px rgba(239, 68, 68, 0.25),
    0 10px 30px rgba(0,0,0,0.45) !important;
}

.publisher-video-screen .offline-ui.offline-ui-up::before,
.videomode .offline-ui.offline-ui-up::before,
html[data-theme="light"] .publisher-video-screen .offline-ui.offline-ui-up::before,
html[data-theme="light"] .videomode .offline-ui.offline-ui-up::before {
  background: #22c55e !important;
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.8) !important;
}

.publisher-video-screen .offline-ui.offline-ui-down::before,
.videomode .offline-ui.offline-ui-down::before,
html[data-theme="light"] .publisher-video-screen .offline-ui.offline-ui-down::before,
html[data-theme="light"] .videomode .offline-ui.offline-ui-down::before {
  background: #ef4444 !important;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.8) !important;
}

/* ---------------------------------------------------
 * OpenTok: force subscriber/publisher to fill container
 * --------------------------------------------------- */
#opentok-container .OT_subscriber,
#opentok-container .OT_publisher {
  width: 100% !important;
  height: 100% !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
}

/* Make opentok-container itself use relative/absolute layout */
.publisher-video-screen #opentok-container {
  position: relative !important;
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  background: #000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.OT_subscriber .OT_widget-container,
.OT_publisher .OT_widget-container {
  width: 100% !important;
  height: 100% !important;
  background: #000 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.OT_subscriber video,
.OT_publisher video {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  object-position: center !important;
  background: #000 !important; /* Black letterbox bars when aspect ratio doesn't match */
}

/* Hide OpenTok's irritating default "camera crossed out" icon that flashes during initialization */
.OT_video-poster,
.OT_publisher .OT_video-poster,
.OT_subscriber .OT_video-poster {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  background-image: none !important;
  background-color: transparent !important;
  width: 0 !important;
  height: 0 !important;
}

/* Also hide any default OpenTok UI overlays that might flash */
.OT_edge-bar-item.OT_mute,
.OT_audio-only-icon,
.OT_video-poster svg,
.OT_audio-only-icon svg,
.OT_root svg {
  display: none !important;
  opacity: 0 !important;
  visibility: hidden !important;
  width: 0 !important;
  height: 0 !important;
}

/* Video Paused Pill (Liquid Glass) */
.video-state-pill {
  background: rgba(0, 0, 0, 0.5);
  color: #ffffff;
  padding: 16px 32px;
  border-radius: 20px;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.video-state-pill-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 600;
}

.video-state-pill-subtitle {
  font-size: 14px;
  opacity: 0.9;
  font-weight: 400;
  max-width: 280px;
  line-height: 1.4;
}

/* Agent Toolbar Icons (Black for better contrast) */
.video-chat-embedded .tools .button i {
  color: #000000 !important;
}
.video-chat-embedded .tools .button.btn-end-call i {
  color: #ffffff !important;
}

/* End Call Modal Contrast Fixes */
.lh-modal .call-end-modal-note-is-ended,
.lh-modal .call-end-modal-duration-title,
.lh-modal .call-end-modal-end-note {
  color: var(--text-secondary) !important;
}

.lh-modal .call-end-modal-duration-value {
  color: var(--text-primary) !important;
}

/* Modal Input Fields */
.lh-modal textarea,
.lh-modal select {
  background-color: #ffffff !important;
  color: #1e293b !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  padding: 12px !important;
  font-family: inherit !important;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05) !important;
}

.lh-modal select {
  padding-right: 32px !important; /* Make room for the dropdown arrow */
}

/* ========================================================= */
/* RESPONSIVE ANONYMOUS LAYOUT (LOGIN, RESET PASSWORD, ETC.) */
/* ========================================================= */

.anonymous-container {
  min-height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: var(--bg-color);
}

.anonymous-card-wrapper {
  position: relative;
  width: 100%;
}

.anonymous-card {
  background-color: var(--panel-bg);
  border-radius: 32px;
  box-shadow: var(--glass-shadow);
  border: 1px solid var(--panel-border);
  overflow: hidden;
}

.anonymous-header {
  position: relative;
  padding: 32px 0;
  border-bottom: 1px solid var(--panel-border);
  background-color: var(--panel-bg);
  display: flex;
  justify-content: center;
  align-items: center;
}

.anonymous-theme-toggle {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

.login-section-left {
  flex: 1 1 400px;
  padding: 48px;
  border-right: 1px solid var(--panel-border);
}

.login-section-right {
  flex: 1 1 400px;
  padding: 48px;
}

.login-icon {
  width: 56px;
  height: 56px;
  object-fit: contain;
  transition: display 0.2s ease;
}

@media (max-width: 767px) {
  .anonymous-container {
    padding: 16px !important;
    justify-content: flex-start !important;
  }
  .anonymous-card-wrapper {
    margin-top: 16px !important;
  }
  .anonymous-card {
    border-radius: 20px !important;
  }
  .anonymous-header {
    padding: 20px 0 !important;
  }
  .anonymous-theme-toggle {
    right: 16px !important;
  }
  .login-section-left,
  .login-section-right {
    padding: 24px !important;
  }
  .login-section-left {
    border-right: none !important;
    border-bottom: 1px solid var(--panel-border) !important;
  }
}

@media (max-width: 500px) {
  .login-icon {
    display: none !important;
  }
}

/* Responsive table utility for mobile and small screens */
.responsive-table td .avatar {
  width: 36px !important;
  height: 36px !important;
  line-height: 36px !important;
  font-size: 14px !important;
  border-radius: 50% !important;
  box-shadow: none !important;
}

@media (max-width: 768px) {
  /* Mobile Layout Fallbacks */
  table.responsive-table,
  table.responsive-table > tbody,
  table.responsive-table > tbody > tr,
  table.responsive-table > tbody > tr > td {
    display: block !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Show table header as a sorting control bar of buttons on mobile */
  table.responsive-table > thead {
    display: block !important;
    margin-bottom: 16px !important;
    width: 100% !important;
  }
  table.responsive-table > thead > tr {
    display: flex !important;
    gap: 12px !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    width: 100% !important;
    box-shadow: none !important;
  }
  table.responsive-table > thead > tr > th {
    display: inline-flex !important;
    flex: 1 !important;
    justify-content: center !important;
    align-items: center !important;
    background: var(--btn-default-bg) !important;
    border: 1px solid var(--btn-default-border) !important;
    border-radius: 8px !important;
    padding: 10px 12px !important;
    font-size: 11px !important;
    color: var(--text-muted) !important;
    text-transform: uppercase !important;
    font-weight: bold !important;
    letter-spacing: 0.05em !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
    text-align: center !important;
    cursor: pointer !important;
    user-select: none !important;
    min-width: auto !important;
    max-width: none !important;
    width: auto !important;
    white-space: nowrap !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
  }
  table.responsive-table > thead > tr > th:last-child {
    display: none !important; /* Hide actions header column */
  }

  /* Table Row Card layout using relative positioning */
  table.responsive-table > tbody > tr {
    display: block !important;
    position: relative !important;
    margin-bottom: 16px !important;
    background: var(--panel-bg) !important;
    border: 1px solid var(--panel-border) !important;
    border-radius: 12px !important;
    padding: 16px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
  }
  table.responsive-table > tbody > tr > td {
    padding: 8px 0 !important;
    border: none !important;
    white-space: normal !important;
    word-break: break-word !important;
    min-width: auto !important;
    max-width: none !important;
    width: auto !important;
  }
  
  /* Customer / User Info Cell (1st cell) aligned left, padded on right for actions */
  table.responsive-table > tbody > tr > td:first-child {
    display: block !important;
    padding-right: 170px !important;
    width: auto !important;
  }

  /* Actions Cell (last cell) absolute positioned top right */
  table.responsive-table > tbody > tr > td:last-child {
    position: absolute !important;
    top: 20px !important;
    right: 16px !important;
    width: auto !important;
    padding: 0 !important;
    display: block !important;
  }
  table.responsive-table > tbody > tr > td:last-child > div {
    display: flex !important;
    justify-content: flex-end !important;
    gap: 8px !important;
  }
  
  /* Separate the header row (1st cell) from the details below with border */
  table.responsive-table > tbody > tr > td:nth-child(2) {
    display: block !important;
    border-top: 1px solid var(--panel-border) !important;
    padding-top: 12px !important;
    margin-top: 8px !important;
    width: 100% !important;
  }
  table.responsive-table > tbody > tr > td:nth-child(3) {
    display: block !important;
    width: 100% !important;
  }

  /* Last Event Cell Layout (label on top, date below, text below that, all aligned left) */
  table.responsive-table > tbody > tr > td.last-event-cell::before {
    content: attr(data-label);
    font-weight: bold;
    color: var(--text-muted);
    display: block !important;
    margin-bottom: 6px !important;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  table.responsive-table > tbody > tr > td.last-event-cell .last-event-date {
    font-size: 13px !important;
    font-weight: bold !important;
    color: var(--text-color) !important;
    display: block !important;
    text-align: left !important;
  }
  table.responsive-table > tbody > tr > td.last-event-cell .last-event-text {
    margin-top: 4px !important;
    font-size: 13px !important;
    color: var(--text-muted) !important;
    display: block !important;
    text-align: left !important;
  }

  /* General fallback label block layout for non-event columns (e.g. Roles/Email) */
  table.responsive-table > tbody > tr > td[data-label]:not(.last-event-cell)::before {
    content: attr(data-label);
    font-weight: bold;
    color: var(--text-muted);
    display: block !important;
    margin-bottom: 6px;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  table.responsive-table .column-resizer {
    display: none !important;
  }
}

/* Streamlined Dropdown Menu Styling */
.dropdown-menu {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
  font-size: 13px !important;
  border-radius: 8px !important;
  border: 1px solid var(--panel-border) !important;
  background-color: var(--dropdown-bg) !important;
  box-shadow: var(--shadow-md) !important;
  padding: 6px 0 !important;
  z-index: 1050 !important;
}

.dropdown-menu > li > a {
  color: var(--text-color) !important;
  padding: 8px 16px !important;
  font-family: inherit !important;
  font-size: inherit !important;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: var(--surface-3) !important;
  color: var(--primary-color) !important;
  text-decoration: none !important;
}

.dropdown-menu > .dropdown-header {
  font-family: inherit !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
  color: var(--text-muted) !important;
  padding: 6px 16px !important;
}
`, "",{"version":3,"sources":["webpack://./src/custom_styles.css"],"names":[],"mappings":"AAGA,mEAAmE;AACnE;EACE,0BAA0B;EAC1B,mGAAmG;EACnG;;;;sIAIoI;EACpI,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;EACE,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,yFAAyF;AACzF;;EAEE,qCAAqC;AACvC;;AAEA,4DAA4D;AAC5D;EACE,2BAA2B,EAAE,aAAa;EAC1C,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,2BAA2B,EAAE,aAAa;AAC5C;AACA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;AACA;EACE,gBAAgB,EAAE,eAAe;AACnC;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D,iDAAiD;AACjD;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D,sFAAsF;AACtF,gGAAgG;AAChG;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;;EAEE,6BAA6B;EAC7B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,iDAAiD;EACjD,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;EACE,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;EACE,2BAA2B,EAAE,mBAAmB;AAClD;AACA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,oCAAoC;AACtC;AACA;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA;EACE,2BAA2B,EAAE,eAAe;AAC9C;AACA;EACE,2BAA2B,EAAE,cAAc;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,2BAA2B,EAAE,WAAW;AAC1C;AACA;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;AACA;EACE,2BAA2B,EAAE,4BAA4B;AAC3D;AACA;EACE,2BAA2B,EAAE,oBAAoB;AACnD;AACA;EACE,2BAA2B,EAAE,kBAAkB;AACjD;;AAEA,wBAAwB;AACxB;EACE,wBAAwB;EACxB,mBAAmB;EACnB,wKAAwK;EACxK,qBAAqB;EACrB,qBAAqB,EAAE,sBAAsB;EAC7C,qBAAqB;;EAErB,+BAA+B;EAC/B,gBAAgB;EAChB,gEAAgE;;EAEhE,iCAAiC;EACjC,yCAAyC;EACzC,mCAAmC;;EAEnC,gCAAgC;EAChC,wCAAwC;EACxC,qCAAqC;EACrC,0BAA0B;EAC1B,2BAA2B;EAC3B,oGAAoG;EACpG,4CAA4C;EAC5C,6CAA6C;;EAE7C,sGAAsG;EACtG,kDAAkD;EAClD,wCAAwC;EACxC,kDAAkD;;EAElD,oCAAoC;EACpC,wCAAwC;EACxC,oBAAoB;;EAEpB,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;;EAElB,2CAA2C;EAC3C,+CAA+C;EAC/C,2BAA2B;EAC3B,iDAAiD;EACjD,qDAAqD;;EAErD,sBAAsB;;EAEtB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;;EAEhC,6EAA6E;EAC7E,mDAAmD;EACnD,6EAA6E;EAC7E,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,wKAAwK;EACxK,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;;EAErB,iBAAiB;EACjB,mBAAmB;EACnB,mEAAmE;;EAEnE,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;;EAEtC,mCAAmC;EACnC,qCAAqC;EACrC,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,kGAAkG;EAClG,6CAA6C;EAC7C,6CAA6C;;EAE7C,sGAAsG;EACtG,kDAAkD;EAClD,2CAA2C;EAC3C,+CAA+C;;EAE/C,iCAAiC;EACjC,qCAAqC;EACrC,oBAAoB;;EAEpB,qCAAqC;EACrC,qCAAqC;EACrC,qBAAqB;;EAErB,0CAA0C;EAC1C,2CAA2C;EAC3C,2BAA2B;EAC3B,gDAAgD;EAChD,iDAAiD;;EAEjD,wCAAwC;;EAExC,2CAA2C;EAC3C,0BAA0B;EAC1B,gCAAgC;;EAEhC,6LAA6L;EAC7L,qDAAqD;EACrD,wDAAwD;EACxD,qFAAqF;EACrF,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,uCAAuC;EACvC,mCAAmC;EACnC,oHAAoH;EACpH,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B,EAAE,oFAAoF;EACjH,uDAAuD;AACzD;;AAEA,0CAA0C;AAC1C;EACE,+CAA+C;EAC/C,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,wCAAwC;AAC1C;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;EACtC,8CAA8C;EAC9C,uDAAuD;EACvD,qDAAqD;EACrD,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,QAAQ;EACR,gDAAgD;EAChD,wCAAwC;EACxC,+CAA+C;AACjD;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,gDAAgD;AAChD;EACE,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,qCAAqC;EACrC,oBAAoB;EACpB,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;;iEAciE;;AAEjE;EACE,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,+EAA+E;AAC/E;EACE,wBAAwB;EACxB,iDAAiD;EACjD,kCAAkC;EAClC,yDAAyD;EACzD,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;EAC9B,wBAAwB;EACxB,iCAAiC;EACjC,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;EACxB,8DAA8D;AAChE;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,kDAAkD;EAClD,+CAA+C;EAC/C,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,4CAA4C;EAC5C,kDAAkD;EAClD,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,QAAQ;EACR,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;;;AAIA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gDAAgD;EAChD,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA,8DAA8D;AAC9D;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;EAC9B,4BAA4B,EAAE,2BAA2B;EACzD,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,iCAAiC;EACjC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,uDAAuD;AACvD;EACE,sBAAsB;EACtB,wBAAwB;EACxB,+BAA+B,EAAE,+EAA+E;EAChH,6BAA6B;EAC7B,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;EAEE,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,8BAA8B;EAC9B,sBAAsB;EACtB,sBAAsB,IAAI,gDAAgD;EAC1E,wBAAwB;EACxB,uBAAuB;EACvB,0CAA0C;EAC1C,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8FAA8F;EAC9F,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,+EAA+E;EAC/E,qBAAqB;EACrB,6BAA6B;EAC7B,2BAA2B;EAC3B,wDAAwD;EACxD,qBAAqB;EACrB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,sBAAsB;EACtB,uBAAuB;EACvB,8DAA8D;AAChE;;AAEA,mBAAmB,oBAAoB,EAAE,sBAAsB,EAAE;;AAEjE;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,6BAA6B;EAC7B,mCAAmC;EACnC,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;EACvB,yBAAyB;EACzB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gDAAgD;EAChD,yDAAyD;EACzD,wBAAwB;AAC1B;;AAEA,+BAA+B,yBAAyB,EAAE;;AAE1D;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,sDAAsD;EACtD,oCAAoC;AACtC;;AAEA;EACE,kDAAkD;EAClD,wDAAwD;AAC1D;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,wDAAwD;EACxD,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;EACxE,wDAAwD;EACxD,sCAAsC;AACxC;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,wDAAwD;EACxD,oCAAoC;EACpC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,wEAAwE;EACxE,sCAAsC;EACtC,wDAAwD;AAC1D;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,iCAAiC;EACjC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,sCAAsC;EACtC,gDAAgD;EAChD,8BAA8B;EAC9B,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,wBAAwB;EACxB,yCAAyC;EACzC,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;EACnC,uDAAuD;EACvD,oBAAoB;AACtB;;AAEA,iFAAiF;;AAEjF;EACE,OAAO,wBAAwB,IAAI,aAAa,EAAE;EAClD,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,IAAI,aAAa,EAAE;AACpD;;AAEA,+EAA+E;;AAE/E;EACE,IAAI,4CAA4C,EAAE,oCAAoC,EAAE;EACxF,mBAAmB,4CAA4C,EAAE,uBAAuB,EAAE,4BAA4B,EAAE;EACxH,cAAc,uBAAuB,EAAE,4BAA4B,EAAE;EACrE,mBAAmB,yBAAyB,EAAE,uBAAuB,EAAE;EACvE,iBAAiB,wBAAwB,EAAE;EAC3C,0BAA0B,wBAAwB,EAAE,8BAA8B,EAAE;EACpF,wBAAwB,wBAAwB,EAAE;EAClD,gBAAgB,uBAAuB,EAAE,4BAA4B,EAAE,kCAAkC,EAAE,uBAAuB,EAAE;EACpI,eAAe,uBAAuB,EAAE,4BAA4B,EAAE;EACtE,QAAQ,wBAAwB,EAAE,mBAAmB,EAAE;AACzD;;;AAGA,kEAAkE;AAClE,kEAAkE;AAClE,kEAAkE;;AAElE;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE;IACE,iDAAiD;IACjD,kCAAkC;EACpC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;;;EAGE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,QAAQ,EAAE,6CAA6C;EACvD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,8FAA8F;AAC9F,8FAA8F;AAC9F,sFAAsF;;AAEtF,mEAAmE;AACnE;EACE;IACE,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,2BAA2B;IAC3B,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,iBAAiB;IACjB,wBAAwB;IACxB,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;EACzB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,iBAAiB;IACjB,OAAO;IACP,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,wCAAwC;IACxC,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,sDAAsD;IACtD,qDAAqD;EACvD;EACA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA,8CAA8C;EAC9C;;;;;;IAME,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA,6BAA6B;AAC7B;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA,oFAAoF;AACpF;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;iFAEiF;AACjF;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,uDAAuD;AACvD;;EAEE,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,sCAAsC;EACtC,YAAY;EACZ,gDAAgD;EAChD,qDAAqD;EACrD,yDAAyD;EACzD,0DAA0D;EAC1D,qDAAqD;EACrD,6DAA6D;EAC7D,8BAA8B,EAAE,uBAAuB;EACvD,4BAA4B;EAC5B,+FAA+F;EAC/F,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,kCAAkC;AAClC;EACE;;IAEE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,4BAA4B,EAAE,gCAAgC;EAC9D,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,6EAA6E;AAC7E;EACE;;IAEE,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,qCAAqC;IACrC,4BAA4B;IAC5B,2BAA2B;IAC3B,iCAAiC;EACnC;EACA;;IAEE,iCAAiC;EACnC;AACF;;AAEA,uBAAuB;AACvB;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,0CAA0C;EAC1C,yBAAyB;EACzB,gDAAgD;EAChD,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,4DAA4D;EAC5D,qBAAqB;EACrB,yBAAyB;EACzB,+DAA+D;AACjE;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,yCAAyC;EACzC,sCAAsC;EACtC,2FAA2F;AAC7F;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE;;IAEE,uBAAuB;IACvB,4BAA4B;EAC9B;EACA;;IAEE,mBAAmB;EACrB;EACA;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,4BAA4B;AAC5B;;EAEE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;AACA;;EAEE,8CAA8C;AAChD;;AAEA,mEAAmE;AACnE;;;EAGE,+CAA+C;EAC/C,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA,sCAAsC;AACtC;;EAEE,8BAA8B;EAC9B,yBAAyB;EACzB,qDAAqD;EACrD,kGAAkG;AACpG;AACA;;EAEE,8BAA8B;EAC9B,kGAAkG;EAClG,kDAAkD;AACpD;;AAEA,kEAAkE;AAClE,kEAAkE;AAClE,kEAAkE;;AAElE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,kDAAkD;EAClD,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,UAAU;EACV,4EAA4E;EAC5E,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;EACrD,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA,6GAA6G;AAC7G;;EAEE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,6CAA6C;EAC7C,sCAAsC;EACtC,8CAA8C;EAC9C,6DAA6D;EAC7D,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,iDAAiD;EACjD,yBAAyB;EACzB,8BAA8B,EAAE,6CAA6C;EAC7E,+BAA+B;AACjC;;;AAGA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;EACE,4CAA4C;EAC5C,6CAA6C;EAC7C,uCAAuC;EACvC,mCAAmC;EACnC,8FAA8F;AAChG;;AAEA,2BAA2B;AAC3B;EACE,uDAAuD;AACzD;;AAEA,gCAAgC;AAChC;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;EAC1C,uDAAuD;AACzD;;AAEA,6BAA6B;AAC7B;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,mCAAmC;EACnC,gDAAgD;EAChD,qDAAqD;EACrD,+FAA+F;AACjG;;AAEA,wBAAwB;AACxB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,uDAAuD;EACvD,yEAAyE;AAC3E;;AAEA,+CAA+C;AAC/C;EACE,gEAAgE;EAChE,uBAAuB;EACvB,uBAAuB;EACvB,yDAAyD;EACzD,oCAAoC;AACtC;;AAEA;EACE,gEAAgE;EAChE,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,aAAa,EAAE,iCAAiC;EAChD,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;;;AAIA,YAAY;AACZ;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2CAA2C;EAC3C,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,sDAAsD;EACxE,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,4CAA4C;EAC5C,iBAAiB;EACjB,mBAAmB;EACnB,sEAAsE;EACtE,UAAU;EACV,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;;wDAEwD;AACxD;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,4CAA4C;EAC5C,sEAAsE;EACtE,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,wBAAwB;EACxB,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,iEAAiE;AACnE;;AAEA,4CAA4C;AAC5C;EACE,6CAA6C;EAC7C,sDAAsD;EACtD,0DAA0D;EAC1D,yBAAyB;EACzB;;;yCAGuC;EACvC,qDAAqD;EACrD,6DAA6D;AAC/D;AACA;EACE;;;yCAGuC;AACzC;AACA;EACE;;;yCAGuC;AACzC;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,sDAAsD;EACtD,6CAA6C;AAC/C;AACA;EACE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,YAAY,0CAA0C,EAAE;AAC1D;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;EAChD,qDAAqD;EACrD,yDAAyD;EACzD,0DAA0D;EAC1D,yBAAyB;EACzB;;uDAEqD;EACrD,qDAAqD;EACrD,6DAA6D;AAC/D;AACA;EACE;;;6CAG2C;AAC7C;AACA;EACE;;;6CAG2C;AAC7C;AACA;EACE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;;;wDAGwD;AACxD;;;EAGE,2BAA2B;AAC7B;;AAEA,0EAA0E;AAC1E;;;;EAIE,6CAA6C;EAC7C,sDAAsD;EACtD,0DAA0D;EAC1D,yBAAyB;EACzB;;;yCAGuC;EACvC,qDAAqD;EACrD,6DAA6D;AAC/D;;AAEA;;;;EAIE;;;2CAGyC;AAC3C;;AAEA;;;;EAIE;;;2CAGyC;AAC3C;;AAEA;;;;EAIE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;;;;EAIE,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;;wDAEwD;AACxD;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B,EAAE,yDAAyD;AACxF;;AAEA,mGAAmG;AACnG;;;EAGE,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,iCAAiC;EACjC,wCAAwC;EACxC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,+DAA+D;AAC/D;;;;;EAKE,wBAAwB;EACxB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;;;EAGE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,uBAAuB;AACvB;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,iDAAiD;AACnD;;AAEA;EACE,8BAA8B,EAAE,qCAAqC;AACvE;;AAEA,8DAA8D;AAC9D,8DAA8D;AAC9D,8DAA8D;;AAE9D;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;IACxB,sCAAsC;EACxC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;IAC7B,uDAAuD;EACzD;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B;;;;IAIE,yBAAyB;IACzB,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA,oEAAoE;EACpE;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,oBAAoB;IACpB,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;IAC9B,4CAA4C;IAC5C,sDAAsD;IACtD,6BAA6B;IAC7B,6BAA6B;IAC7B,0BAA0B;IAC1B,mCAAmC;IACnC,oCAAoC;IACpC,4BAA4B;IAC5B,iCAAiC;IACjC,oDAAoD;IACpD,6BAA6B;IAC7B,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;IACtB,8BAA8B;IAC9B,kCAAkC;IAClC,2BAA2B;EAC7B;EACA;IACE,wBAAwB,EAAE,+BAA+B;EAC3D;;EAEA,qDAAqD;EACrD;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;IAC9B,sCAAsC;IACtC,gDAAgD;IAChD,8BAA8B;IAC9B,wBAAwB;IACxB,oDAAoD;EACtD;EACA;IACE,yBAAyB;IACzB,uBAAuB;IACvB,8BAA8B;IAC9B,iCAAiC;IACjC,0BAA0B;IAC1B,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA,mFAAmF;EACnF;IACE,yBAAyB;IACzB,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA,2DAA2D;EAC3D;IACE,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,oCAAoC;IACpC,mBAAmB;EACrB;;EAEA,0EAA0E;EAC1E;IACE,yBAAyB;IACzB,oDAAoD;IACpD,4BAA4B;IAC5B,0BAA0B;IAC1B,sBAAsB;EACxB;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,yFAAyF;EACzF;IACE,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,mCAAmC;IACnC,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,0BAA0B;IAC1B,mCAAmC;IACnC,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA,iFAAiF;EACjF;IACE,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,sCAAsC;AACtC;EACE,oHAAoH;EACpH,0BAA0B;EAC1B,6BAA6B;EAC7B,gDAAgD;EAChD,+CAA+C;EAC/C,uCAAuC;EACvC,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,+BAA+B;EAC/B,6BAA6B;EAC7B,yDAAyD;AAC3D;;AAEA;;EAEE,6CAA6C;EAC7C,sCAAsC;EACtC,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;EAC3B,oCAAoC;EACpC,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');\n\n/* Ensure FontAwesome loads from CDNJS if local files are missing */\n@font-face {\n  font-family: 'FontAwesome';\n  src: url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.eot');\n  src: url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?#iefix&v=4.7.0') format('embedded-opentype'),\n       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2') format('woff2'),\n       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.woff') format('woff'),\n       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf') format('truetype'),\n       url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/fonts/fontawesome-webfont.svg#fontawesomeregular') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Map missing custom icomoon/Glyphicons to FontAwesome so they display correctly */\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  font-family: 'FontAwesome' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Force FontAwesome font-family with higher specificity to prevent fonts.less override */\nhtml [class^=\"icon-\"], html [class*=\" icon-\"],\nhtml [class^=\"icon-\"]::before, html [class*=\" icon-\"]::before {\n  font-family: 'FontAwesome' !important;\n}\n\n/* Specific mappings for key icomoon icons used in the app */\n.icon-phone-down::before {\n  content: '\\f095' !important; /* fa-phone */\n  display: inline-block !important;\n  transform: rotate(135deg) !important;\n}\n.icon-phone::before {\n  content: '\\f095' !important; /* fa-phone */\n}\n.icon-left::before {\n  content: '\\f104' !important; /* fa-angle-left */\n}\n.icon-screenshare::before {\n  content: '\\f108'; /* fa-desktop */\n}\n\n/* ========================================================= */\n/* CUSTOMER SCREENSHARE LAYOUT                               */\n/* ========================================================= */\n\n/* Container Setup when Screensharing is active */\n#opentok-container.has-screenshare {\n  display: flex !important;\n  flex-direction: column;\n  position: relative;\n  background: #111 !important;\n  overflow: hidden;\n}\n\n/* Picture-in-Picture logic for when a screenshare is active */\n/* In UserVideo.js (Agent view), screenshare is published and remote video is viewed */\n/* In EndkundeVideo.js (Customer view), screenshare is subscribed and local video is published */\n#opentok-container.has-screenshare .OT_subscriber.OT_video-type-screen,\n#opentok-container.has-screenshare .OT_publisher.OT_video-type-screen {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  width: 100% !important;\n  height: 100% !important;\n  z-index: 1 !important;\n}\n\n/* Base styles for all PiP cameras */\n#opentok-container.has-screenshare .OT_publisher:not(.OT_video-type-screen),\n#opentok-container.has-screenshare .OT_subscriber:not(.OT_video-type-screen) {\n  position: absolute !important;\n  top: auto !important;\n  left: auto !important;\n  bottom: 20px !important;\n  width: 120px !important;\n  height: 160px !important;\n  z-index: 100 !important;\n  border-radius: 12px !important;\n  overflow: hidden !important;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.3) !important;\n  border: 2px solid rgba(255,255,255,0.2) !important;\n  transition: all 0.3s ease;\n}\n\n/* Offset the first PiP to the right */\n#opentok-container.has-screenshare .OT_publisher:not(.OT_video-type-screen) {\n  right: 20px !important;\n}\n\n/* Offset the second PiP to the left of the first one */\n#opentok-container.has-screenshare .OT_subscriber:not(.OT_video-type-screen) {\n  right: 160px !important;\n}\n\n/* Removed mobile split view override so PiP works universally on all devices */\n.icon-right::before {\n  content: '\\f105' !important; /* fa-angle-right */\n}\n.icon-phone-down2::before, .icon-call-end2::before {\n  content: '\\f095' !important;\n  display: inline-block !important;\n  transform: rotate(135deg) !important;\n}\n.icon-camera::before {\n  content: '\\f03d' !important; /* fa-video-camera */\n}\n.icon-camera-turn::before {\n  content: '\\f021' !important; /* fa-refresh */\n}\n.icon-fullscreen::before, .icon-fullsreen2::before {\n  content: '\\f065' !important; /* fa-expand */\n}\n\n/* Map missing Glyphicons to FontAwesome */\n.glyphicon {\n  font-family: 'FontAwesome' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.glyphicon-cog::before {\n  content: '\\f013' !important; /* fa-cog */\n}\n.glyphicon-chevron-down::before {\n  content: '\\f078' !important; /* fa-chevron-down */\n}\n.glyphicon-chevron-up::before {\n  content: '\\f077' !important; /* fa-chevron-up */\n}\n.glyphicon-warning-sign::before {\n  content: '\\f071' !important; /* fa-exclamation-triangle */\n}\n.glyphicon-ok-sign::before {\n  content: '\\f058' !important; /* fa-check-circle */\n}\n.glyphicon-volume-off::before {\n  content: '\\f026' !important; /* fa-volume-off */\n}\n\n/* CSS Theme Variables */\n:root {\n  /* Default: Dark Theme */\n  --bg-color: #040814;\n  --aurora-bg: radial-gradient(circle at 15% 40%, rgba(6, 182, 212, 0.12), transparent 45%), radial-gradient(circle at 85% 60%, rgba(38, 167, 223, 0.15), transparent 45%);\n  --text-color: #f1f5f9;\n  --text-muted: #a1b0c7; /* Improved contrast */\n  --focus-ring: #60a5fa;\n  \n  --nav-bg: rgba(15, 23, 42, 0.9);\n  --nav-text: #fff;\n  --nav-brand-gradient: linear-gradient(135deg, #fff 50%, #60a5fa);\n  \n  --panel-bg: rgba(15, 23, 42, 0.4);\n  --panel-border: rgba(255, 255, 255, 0.06);\n  --panel-shadow: rgba(0, 0, 0, 0.25);\n  \n  --card-bg: rgba(30, 41, 59, 0.3);\n  --card-border: rgba(255, 255, 255, 0.05);\n  --card-text: rgba(38, 167, 223, 0.85);\n  --card-text-hover: #26a7df;\n  --card-text-active: #00c5ff;\n  --card-bg-active: linear-gradient(135deg, rgba(38, 167, 223, 0.15) 0%, rgba(0, 197, 255, 0.15) 100%);\n  --card-border-active: rgba(0, 197, 255, 0.3);\n  --card-shadow-active: rgba(0, 197, 255, 0.15);\n  \n  --chat-bubble-out: linear-gradient(135deg, rgba(99, 102, 241, 0.16) 0%, rgba(139, 92, 246, 0.16) 100%);\n  --chat-bubble-out-border: rgba(139, 92, 246, 0.25);\n  --chat-bubble-in: rgba(30, 41, 59, 0.45);\n  --chat-bubble-in-border: rgba(255, 255, 255, 0.05);\n  \n  --pill-bg: rgba(255, 255, 255, 0.03);\n  --pill-border: rgba(255, 255, 255, 0.06);\n  --pill-text: #94a3b8;\n  \n  --input-bg: rgba(0, 0, 0, 0.25);\n  --input-border: rgba(255, 255, 255, 0.08);\n  --input-text: #fff;\n  \n  --btn-default-bg: rgba(255, 255, 255, 0.04);\n  --btn-default-border: rgba(255, 255, 255, 0.08);\n  --btn-default-text: #cbd5e1;\n  --btn-default-hover-bg: rgba(255, 255, 255, 0.08);\n  --btn-default-hover-border: rgba(255, 255, 255, 0.15);\n  \n  --dropdown-bg: #1e293b;\n  \n  --scrollbar-track: #0d111a;\n  --scrollbar-thumb: #1e293b;\n  --scrollbar-thumb-hover: #0284c7;\n  \n  --video-backdrop: radial-gradient(circle at center, #1e293b 0%, #090d16 100%);\n  --video-shadow: inset 0 0 100px rgba(0, 0, 0, 0.85);\n  --glass-shadow: 0 25px 60px rgba(0, 0, 0, 0.5), 0 8px 20px rgba(0, 0, 0, 0.3);\n  --overlay-bg: #0f172a;\n}\n\n/* Light Theme Variables overrides */\nhtml[data-theme=\"light\"] {\n  --bg-color: #f1f5f9;\n  --bg: #f1f5f9;\n  --surface: #ffffff;\n  --surface-2: #f1f5f9;\n  --surface-3: #e2e8f0;\n  --surface-color: var(--surface);\n  --border: rgba(15, 23, 42, 0.08);\n  --border-color: var(--border);\n  --aurora-bg: radial-gradient(circle at 15% 40%, rgba(6, 182, 212, 0.06), transparent 45%), radial-gradient(circle at 85% 60%, rgba(38, 167, 223, 0.06), transparent 45%);\n  --text-color: #1e293b;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --text-muted: #475569; \n  --focus-ring: #0284c7;\n  \n  --nav-bg: #ffffff;\n  --nav-text: #1e293b;\n  --nav-brand-gradient: linear-gradient(135deg, #1e293b 50%, #0284c7);\n  \n  --panel-bg: #ffffff;\n  --panel-border: rgba(15, 23, 42, 0.06);\n  --panel-shadow: rgba(15, 23, 42, 0.08);\n  \n  --card-bg: rgba(255, 255, 255, 0.5);\n  --card-border: rgba(15, 23, 42, 0.05);\n  --card-text: rgba(2, 132, 199, 0.9);\n  --card-text-hover: #0284c7;\n  --card-text-active: #0369a1;\n  --card-bg-active: linear-gradient(135deg, rgba(2, 132, 199, 0.1) 0%, rgba(14, 165, 233, 0.1) 100%);\n  --card-border-active: rgba(2, 132, 199, 0.25);\n  --card-shadow-active: rgba(2, 132, 199, 0.15);\n  \n  --chat-bubble-out: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(139, 92, 246, 0.08) 100%);\n  --chat-bubble-out-border: rgba(139, 92, 246, 0.15);\n  --chat-bubble-in: rgba(255, 255, 255, 0.75);\n  --chat-bubble-in-border: rgba(15, 23, 42, 0.06);\n  \n  --pill-bg: rgba(15, 23, 42, 0.04);\n  --pill-border: rgba(15, 23, 42, 0.08);\n  --pill-text: #475569;\n  \n  --input-bg: rgba(255, 255, 255, 0.75);\n  --input-border: rgba(15, 23, 42, 0.1);\n  --input-text: #1e293b;\n  \n  --btn-default-bg: rgba(255, 255, 255, 0.6);\n  --btn-default-border: rgba(15, 23, 42, 0.1);\n  --btn-default-text: #334155;\n  --btn-default-hover-bg: rgba(255, 255, 255, 0.9);\n  --btn-default-hover-border: rgba(15, 23, 42, 0.2);\n  \n  --dropdown-bg: rgba(255, 255, 255, 0.95);\n  \n  --scrollbar-track: rgba(241, 245, 249, 0.5);\n  --scrollbar-thumb: #cbd5e1;\n  --scrollbar-thumb-hover: #94a3b8;\n  \n  --video-backdrop: radial-gradient(circle at 15% 40%, rgba(14, 165, 233, 0.15) 0%, transparent 50%), radial-gradient(circle at 85% 60%, rgba(99, 102, 241, 0.15) 0%, transparent 50%), #eef2f6;\n  --video-shadow: inset 0 0 60px rgba(15, 23, 42, 0.05);\n  --video-text-shadow: 0 2px 10px rgba(255, 255, 255, 0.5);\n  --glass-shadow: 0 25px 60px rgba(15, 23, 42, 0.12), 0 8px 20px rgba(15, 23, 42, 0.06);\n  --overlay-bg: #ffffff;\n}\n\n/* Base Styles & Full-screen Reset overrides */\nbody, html {\n  background-color: var(--bg-color) !important;\n  background-image: var(--aurora-bg) !important;\n  background-attachment: fixed !important;\n  color: var(--text-color) !important;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif !important;\n  height: 100vh !important;\n  width: 100vw !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important; /* Allow vertical scrolling for long pages (e.g. Terms of Service, pre-call check) */\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n/* Global Focus Styles for Accessibility */\n*:focus-visible {\n  outline: 2px solid var(--focus-ring) !important;\n  outline-offset: 2px !important;\n}\n\n*:focus:not(:focus-visible) {\n  outline: none !important;\n}\n\n#app, .portrait, .navigation {\n  min-height: 100vh !important;\n  width: 100% !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 3px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: var(--scrollbar-thumb-hover);\n}\n\n/* Floating Glassmorphic Navbar (Header) */\n.navbar-default {\n  flex: 0 0 auto !important;\n  background: var(--nav-bg) !important;\n  backdrop-filter: blur(20px) !important;\n  -webkit-backdrop-filter: blur(20px) !important;\n  border-bottom: 1px solid var(--panel-border) !important;\n  box-shadow: 0 4px 20px var(--panel-shadow) !important;\n  margin-bottom: 0 !important;\n  padding: 10px 0 !important;\n  z-index: 100 !important;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.navbar-default .navbar-brand {\n  font-weight: 700 !important;\n  color: var(--nav-text) !important;\n  letter-spacing: -0.5px;\n  display: inline-flex !important;\n  align-items: center;\n  gap: 8px;\n  background: var(--nav-brand-gradient) !important;\n  -webkit-background-clip: text !important;\n  -webkit-text-fill-color: transparent !important;\n}\n\n.breadcrumb-menu li a {\n  color: var(--text-muted) !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  transition: color 0.25s ease !important;\n}\n\n.breadcrumb-menu li a:hover {\n  color: #3b82f6 !important;\n  text-decoration: none !important;\n}\n\n.breadcrumb-menu li + li:before {\n  color: var(--panel-border) !important;\n}\n\n.user-menu li span {\n  color: var(--text-color) !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n}\n\n.user-menu li a {\n  color: var(--text-muted) !important;\n  font-weight: 500 !important;\n  transition: color 0.25s ease !important;\n}\n\n.user-menu li a:hover {\n  color: #3b82f6 !important;\n  text-decoration: none !important;\n}\n\n/* Dashboard Container filling remaining space */\n.content-bg {\n  flex: 1 1 auto !important;\n  width: 100% !important;\n  max-width: 100% !important;\n  height: calc(100vh - 70px) !important;\n  margin: 0 !important;\n  padding: 16px !important;\n  background: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  transition: background-color 0.3s ease;\n}\n\n/* ============================================================\n   GRID LAYOUT — Dashboard\n   ─────────────────────────────────────────────────────────\n   Actual React DOM (after this CSS):\n\n   .customer-single (Flex column)\n     NavBarConfig\n     .layout-3-col   (CSS Grid container, flex: 1)\n       .layout-left     → grid-area: sidebar    (order list)\n       .layout-center   → grid-area: center     (flex column)\n         .video-chat-header   (flex-shrink:0)\n         .layout-video-area   (flex:1 — video fills space)\n         .chat-input          (flex-shrink:0 — pinned bottom)\n       .layout-right.inner-middle → grid-area: timeline (flex column, events)\n   ============================================================ */\n\n.customer-single {\n  display: flex !important;\n  flex-direction: column !important;\n  height: 100vh !important;\n  width: 100vw !important;\n  overflow: hidden !important;\n}\n\n/* The grid itself now applied to the wrapper that contains exactly 3 columns */\n.layout-3-col {\n  display: grid !important;\n  grid-template-columns: 230px 1fr 300px !important;\n  grid-template-rows: 1fr !important;\n  grid-template-areas: \"sidebar center timeline\" !important;\n  gap: 10px !important;\n  flex: 1 1 auto !important;\n  width: 100% !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n  overflow: hidden !important;\n  padding: 10px !important;\n}\n\n.middle {\n  display: contents !important;\n}\n\n/* ── 1. LEFT: Sidebar ───────────────────────────────────── */\n.layout-left {\n  grid-area: sidebar !important;\n  display: flex !important;\n  flex-direction: column !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n}\n\n.order-sidebar {\n  flex: 1 1 auto !important;\n  background: var(--panel-bg) !important;\n  border: 1px solid var(--panel-border) !important;\n  border-radius: 16px !important;\n  padding: 16px !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  min-height: 0 !important;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.order-sidebar h4 {\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  font-size: 12px !important;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin: 0 0 12px 0 !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex: 0 0 auto !important;\n}\n\n.order-sidebar h4 small {\n  font-size: 11px !important;\n  text-transform: none;\n  color: var(--card-text-hover) !important;\n  cursor: pointer;\n}\n\n.order-sidebar-toggle, .order-header-mobile {\n  display: none !important;\n}\n\n.orders {\n  flex: 1 1 auto !important;\n  overflow-y: auto !important;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-height: 0;\n}\n\n.order-sidebar .order {\n  display: flex !important;\n  width: 100% !important;\n  background: transparent !important;\n  border: none !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  flex: 0 0 auto !important;\n}\n\n.order-sidebar .order a {\n  text-decoration: none !important;\n  display: block !important;\n  width: 100% !important;\n}\n\n.order-sidebar .order .text {\n  background: var(--card-bg) !important;\n  border: 1px solid var(--card-border) !important;\n  border-radius: 8px !important;\n  padding: 7px 10px !important;\n  font-size: 13px !important;\n  color: var(--card-text) !important;\n  cursor: pointer !important;\n  width: 100% !important;\n  display: flex !important;\n  align-items: center !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box !important;\n  text-decoration: none !important;\n}\n\n.order-sidebar .order:hover .text {\n  background: var(--btn-default-hover-bg) !important;\n  border-color: var(--card-text-hover) !important;\n  color: var(--card-text-hover) !important;\n  transform: translateX(2px) !important;\n}\n\n.order-sidebar .order.active {\n  background: var(--card-bg-active) !important;\n  border-color: var(--card-border-active) !important;\n  color: var(--text-color) !important;\n}\n\n.order-sidebar .order.active .text {\n  background: transparent !important;\n  border-color: transparent !important;\n  color: var(--text-color) !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n}\n\n.order-sidebar .order a:hover .text, .order-sidebar .order a:hover {\n  color: var(--card-text-hover) !important;\n  text-decoration: none !important;\n}\n\n.order-sidebar .order.active a, .order-sidebar .order.active a .text {\n  color: var(--card-text-active) !important;\n  text-decoration: none !important;\n}\n\n.order.finished .fa-check {\n  color: #10b981 !important;\n  margin-left: auto;\n}\n\n/* Project Hover Actions */\n.hover-parent .hover-actions-menu {\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  background: inherit;\n  padding-left: 8px;\n}\n\n.hover-parent:hover .hover-actions-menu {\n  opacity: 1;\n}\n\n.hover-actions-menu .action-icon {\n  font-size: 13px;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.hover-actions-menu .action-icon:hover {\n  color: var(--text-color);\n  background: rgba(0, 0, 0, 0.05);\n}\n\n\n\n.new-order {\n  flex: 0 0 auto !important;\n  background: var(--input-bg) !important;\n  border: 1px solid var(--input-border) !important;\n  border-radius: 8px !important;\n  color: var(--input-text) !important;\n  font-size: 13px !important;\n  padding: 8px 12px !important;\n  margin-top: 12px !important;\n  width: 100% !important;\n  transition: all 0.2s ease !important;\n  box-sizing: border-box;\n}\n\n.new-order:focus {\n  border-color: var(--card-text-active) !important;\n  box-shadow: 0 0 10px var(--card-shadow-active) !important;\n  outline: none !important;\n}\n\n/* ── 2. CENTER: Header + Video + Note Input ─────────────── */\n.layout-center {\n  grid-area: center !important;\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 10px !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  overflow: hidden !important;\n  padding-bottom: 24px;\n}\n\n/* Modern Initials / Avatar Styling */\n.avatar {\n  background: rgba(59, 130, 246, 0.15) !important;\n  color: #3b82f6 !important;\n  border: none !important;\n  font-weight: 700 !important;\n  font-size: 20px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  box-shadow: 0 4px 10px rgba(59, 130, 246, 0.1) !important;\n  transition: all 0.3s ease !important;\n}\n\n/* Customer header bar */\n.video-chat-header {\n  flex: 0 0 auto !important;\n  background: var(--panel-bg) !important;\n  border: 1px solid var(--panel-border) !important;\n  border-radius: 14px !important;\n  padding: 8px 16px !important; /* reduced from 12px 18px */\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  box-sizing: border-box !important;\n  min-width: 0 !important;\n  transition: background-color 0.3s ease;\n}\n\n.video-chat-header .customer-sub-title {\n  font-size: 20px !important;\n  font-weight: 700 !important;\n  color: var(--text-color) !important;\n  margin-bottom: 2px !important;\n}\n\n/* Video wrapper — fills all available vertical space */\n.layout-video-area {\n  flex: 1 1 0 !important;\n  min-height: 0 !important;\n  max-height: calc(100vh - 290px); /* navbar ~50px + header ~60px + ChatInput ~60px + gaps ~80px + padding ~40px */\n  position: relative !important;\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n}\n\n.layout-video-area .video-status-container,\n.layout-video-area > * {\n  flex: 1 1 0 !important;\n  min-height: 0 !important;\n}\n\n.video-status-container {\n  background: var(--video-backdrop) !important;\n  border: 1px solid var(--panel-border) !important;\n  border-radius: 18px !important;\n  width: 100% !important;\n  flex: 1 1 0 !important;   /* fills parent, but never pushes siblings out */\n  min-height: 0 !important;\n  min-width: 0 !important;\n  box-shadow: var(--video-shadow) !important;\n  display: flex !important;\n  flex-direction: column !important;\n  justify-content: center !important;\n  align-items: center !important;\n  position: relative !important;\n  box-sizing: border-box !important;\n  overflow: hidden !important;\n  transition: border-color 0.3s ease;\n}\n\n.video-status-container::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(45deg, rgba(59, 130, 246, 0.03) 0%, rgba(139, 92, 246, 0.03) 100%);\n  z-index: 1;\n}\n\n.video-status-container .video-status-message {\n  background-color: transparent !important;\n  max-width: 75% !important;\n  font-size: 18px !important;\n  font-weight: 600 !important;\n  color: var(--text-color) !important;\n  text-shadow: var(--video-text-shadow, 0 4px 12px rgba(0, 0, 0, 0.7)) !important;\n  z-index: 2 !important;\n  text-align: center !important;\n  line-height: 1.5 !important;\n  animation: floatPulse 3s ease-in-out infinite !important;\n  padding: 0 !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n\n/* Note / chat input — pinned at bottom of center column */\n.chat-input {\n  flex: 0 0 auto !important;\n  background: var(--panel-bg) !important;\n  border: 1px solid var(--panel-border) !important;\n  border-radius: 14px !important;\n  padding: 10px 14px !important;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  min-width: 0 !important;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.chat-input form { margin: 0 !important; width: 100% !important; }\n\n.chat-input .input-group {\n  width: 100% !important;\n  display: flex !important;\n  gap: 8px !important;\n  align-items: center !important;\n}\n\n.chat-input .form-control {\n  background: var(--input-bg) !important;\n  border: 1px solid var(--input-border) !important;\n  border-radius: 8px !important;\n  color: var(--input-text) !important;\n  font-size: 13px !important;\n  padding: 8px 12px !important;\n  height: 38px !important;\n  flex: 1 1 auto !important;\n  box-sizing: border-box !important;\n  transition: all 0.2s ease !important;\n}\n\n.chat-input .form-control:focus {\n  border-color: var(--card-text-active) !important;\n  box-shadow: 0 0 10px var(--card-shadow-active) !important;\n  outline: none !important;\n}\n\n.chat-input .input-group-btn { flex: 0 0 auto !important; }\n\n.lh-btn {\n  border-radius: 8px !important;\n  padding: 10px 20px !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  letter-spacing: 0.2px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  font-size: 14px !important;\n}\n\n.lh-btn-small, .lh-btn-extra-small {\n  padding: 8px 16px !important;\n  font-size: 13px !important;\n  border-radius: 6px !important;\n}\n\n.lh-btn-default {\n  background: var(--btn-default-bg) !important;\n  color: var(--text-color) !important;\n  border: 1px solid var(--btn-default-border) !important;\n  transition: all 0.2s ease !important;\n}\n\n.lh-btn-default:hover {\n  background: var(--btn-default-hover-bg) !important;\n  border-color: var(--btn-default-hover-border) !important;\n}\n\n.lh-btn-primary {\n  background: linear-gradient(135deg, #0284c7 0%, #2563eb 100%) !important;\n  color: #fff !important;\n  box-shadow: 0 4px 14px rgba(2, 132, 199, 0.3) !important;\n  border: none !important;\n}\n\n.lh-btn-primary:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;\n  box-shadow: 0 5px 16px rgba(37, 99, 235, 0.5) !important;\n  transform: translateY(-1px) !important;\n}\n\n.chat-input .btn-default {\n  background: linear-gradient(135deg, #0284c7 0%, #2563eb 100%) !important;\n  color: #fff !important;\n  border: none !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  border-radius: 8px !important;\n  padding: 0 14px !important;\n  height: 38px !important;\n  box-shadow: 0 3px 10px rgba(2, 132, 199, 0.3) !important;\n  transition: all 0.2s ease !important;\n  cursor: pointer !important;\n  white-space: nowrap !important;\n}\n\n.chat-input .btn-default:hover {\n  background: linear-gradient(135deg, #2563eb 0%, #4f46e5 100%) !important;\n  transform: translateY(-1px) !important;\n  box-shadow: 0 5px 16px rgba(37, 99, 235, 0.5) !important;\n}\n\n/* ── 3. RIGHT: Event Timeline ───────────────────────────── */\n.inner-middle {\n  display: flex !important;\n  flex-direction: column !important;\n  overflow: hidden !important;\n  min-height: 0 !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n  background: var(--panel-bg) !important;\n  border: 1px solid var(--panel-border) !important;\n  border-radius: 16px !important;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.order-header {\n  flex: 0 0 auto !important;\n  padding: 12px 16px !important;\n  border-bottom: 1px solid var(--panel-border) !important;\n}\n\n.event-items {\n  flex: 1 1 auto !important;\n  overflow-y: auto !important;\n  min-height: 0 !important;\n  padding: 10px 8px !important;\n  display: flex !important;\n  flex-direction: column-reverse !important;\n  gap: 6px !important;\n  box-sizing: border-box !important;\n}\n\n/* Timeline title */\n.inner-middle > h5,\n.inner-middle > .timeline-title {\n  flex: 0 0 auto !important;\n  padding: 14px 16px 10px !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.5px !important;\n  color: var(--text-muted) !important;\n  border-bottom: 1px solid var(--panel-border) !important;\n  margin: 0 !important;\n}\n\n/* ─── Animations ────────────────────────────────────────────────────────────  */\n\n@keyframes floatPulse {\n  0%   { transform: translateY(0);   opacity: 0.85; }\n  50%  { transform: translateY(-4px); opacity: 1; }\n  100% { transform: translateY(0);   opacity: 0.85; }\n}\n\n/* ─── Print ──────────────────────────────────────────────────────────────── */\n\n@media print {\n  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }\n  body, html, #app { background-color: var(--bg-color) !important; height: auto !important; overflow: visible !important; }\n  .content-bg { height: auto !important; overflow: visible !important; }\n  .customer-single { display: block !important; height: auto !important; }\n  .order-sidebar { display: none !important; }\n  .video-status-container { height: 400px !important; margin-bottom: 24px !important; }\n  .video-status-toolbar { display: none !important; }\n  .inner-middle { height: auto !important; overflow: visible !important; background: transparent !important; border: none !important; }\n  .event-items { height: auto !important; overflow: visible !important; }\n  .call { page-break-inside: avoid; break-inside: avoid; }\n}\n\n\n/* ───────────────────────────────────────────────────────────── */\n/* RESPONSIVE CUSTOMER DASHBOARD GRID (Video-Stream)             */\n/* ───────────────────────────────────────────────────────────── */\n\n.customer-dashboard-grid {\n  display: grid;\n  flex: 1 1 auto;\n  height: 100% !important;\n  overflow: hidden;\n  min-height: 0;\n  gap: 16px;\n  padding: 0;\n  box-sizing: border-box;\n  position: relative;\n}\n\n/* Default Desktop Layout */\n@media (min-width: 1101px) {\n  .customer-dashboard-grid {\n    grid-template-columns: 220px minmax(0, 1fr) 300px;\n    grid-template-rows: minmax(0, 1fr);\n  }\n\n  .customer-dashboard-grid.sidebar-closed {\n    grid-template-columns: minmax(0, 1fr) 300px;\n  }\n\n  .customer-dashboard-grid.sidebar-closed .customer-left-column {\n    display: none !important;\n  }\n}\n\n/* Base styles for columns */\n.customer-left-column,\n.customer-center-column,\n.customer-right-column {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  min-height: 0;\n  min-width: 0;\n}\n\n.customer-left-column .order-sidebar {\n  border-radius: 0 !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-bottom: none !important;\n  border-right: 1px solid var(--panel-border) !important;\n  height: 100% !important;\n}\n\n.customer-center-column {\n  width: 100%;\n  gap: 8px; /* reduced from 16px to save vertical space */\n  padding: 16px 0;\n}\n\n.customer-right-column {\n  background: var(--panel-bg);\n  border-radius: 16px;\n  border: 1px solid var(--panel-border);\n  margin: 16px 16px 16px 0;\n}\n\n/* Desktop with active call: Hide Left Column (REMOVED: the user requested to always see it) */\n/* .customer-dashboard-grid.has-active-call { grid-template-columns: minmax(0, 1fr) 300px; } */\n/* .customer-dashboard-grid.has-active-call .customer-left-column { display: none; } */\n\n/* Tablets & Mobile (screen <= 1100px) - Full Height Video Layout */\n@media (max-width: 1100px) {\n  .customer-dashboard-grid {\n    display: flex !important;\n    flex-direction: column !important;\n    height: 100% !important;\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    gap: 0 !important;\n    overflow: hidden !important;\n    position: relative !important;\n  }\n  .customer-center-column {\n    flex: 1 1 auto !important;\n    height: 100% !important;\n    width: 100% !important;\n    padding: 0 !important;\n    margin: 0 !important;\n    gap: 0 !important;\n    min-height: 0 !important;\n    position: relative !important;\n  }\n  .customer-center-column .layout-video-area {\n    flex: 1 1 auto !important;\n    height: 100% !important;\n    width: 100% !important;\n    border-radius: 0 !important;\n    min-height: 0 !important;\n    min-width: 0 !important;\n  }\n  .customer-right-column.desktop-only,\n  .desktop-chat-input {\n    display: none !important;\n  }\n  .customer-left-column {\n    display: none;\n  }\n  .customer-left-column.active {\n    display: flex !important;\n    position: absolute !important;\n    top: 0 !important;\n    left: 0;\n    width: 220px !important;\n    height: 100% !important;\n    z-index: 1000 !important;\n    background: var(--overlay-bg) !important;\n    padding: 0 !important;\n    box-sizing: border-box;\n    margin: 0 !important;\n    border-right: 1px solid var(--panel-border) !important;\n    box-shadow: 4px 0 12px rgba(0, 0, 0, 0.15) !important;\n  }\n  .customer-left-column.active .order-sidebar {\n    display: flex !important;\n    flex: 1 1 auto !important;\n    width: 100% !important;\n    height: 100% !important;\n    border-radius: 0 !important;\n    border: none !important;\n    box-shadow: none !important;\n    padding-top: 16px !important;\n  }\n\n  /* Full container sizing for video on mobile */\n  .videomode,\n  .video-chat-embedded,\n  .videomode .video-wrapper,\n  .videomode .video-box.embedded,\n  .videomode #opentok-container,\n  .video-chat-embedded #opentok-container {\n    width: 100% !important;\n    height: 100% !important;\n    max-width: 100% !important;\n    max-height: 100% !important;\n    border-radius: 0 !important;\n  }\n}\n\n@media (max-width: 992px) {\n  .sidebar-container {\n    background-color: var(--overlay-bg) !important;\n  }\n}\n\n/* Project Sidebar Redesign */\n.all-events-link {\n  text-decoration: none;\n}\n\n.new-order-top {\n  margin-bottom: 15px;\n}\n\n.project-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 15px;\n}\n\n.project-card-link {\n  text-decoration: none;\n  display: block;\n}\n\n.project-card {\n  background: white;\n  border-radius: 6px;\n  padding: 12px 15px;\n  border: 1px solid #e0e0e0;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n}\n.project-card:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px rgba(0,0,0,0.08);\n  border-color: #d0d7de;\n}\n.project-card.active {\n  border-color: #007bff;\n  box-shadow: 0 0 0 1px #007bff;\n}\n.project-card .text {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.project-icon {\n  margin-right: 10px;\n  color: #6c757d;\n  font-size: 1.2em;\n}\n/* Removed .project-card.active .project-icon color override so inline styles work */\n.project-name {\n  flex-grow: 1;\n  color: #333;\n  font-weight: 500;\n}\n.check-icon {\n  color: #28a745;\n  margin-left: 10px;\n}\n\n/* ========================================================= */\n/* AGENT VIDEO VIEW REDESIGN (CustomerSinglePage)            */\n/* ========================================================= */\n\n/* 1. Modernisierung des Video-Containers */\n.videomode.video-chat-embedded {\n  position: relative;\n  background-color: transparent !important;\n  border-radius: 18px !important;\n  overflow: hidden;\n  box-shadow: none !important;\n  display: flex !important;\n  flex: 1 1 auto !important;\n  flex-direction: column !important;\n  height: 100% !important;\n  min-height: 400px !important;\n}\n\n.videomode .video-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 18px;\n  overflow: hidden;\n  background: transparent;\n}\n\n/* Fix: .video div (the direct child of .publisher-video-screen) must fill parent.\n * Must be position:relative (not absolute) so its bounding rect correctly reflects\n * the actual video area for tele-point (touch marker) coordinate calculations. */\n.publisher-video-screen .video,\n.publisher-video-screen .videomode {\n  position: relative !important;\n  width: 100% !important;\n  height: 100% !important;\n}\n\n/* Ensure the opentok container takes full space */\n.videomode #opentok-container {\n  width: 100% !important;\n  height: 100% !important;\n  background-color: #000 !important;\n}\n\n/* 2. Floating Toolbar (Tools.js) - Compact & Elegant */\n.videomode .tools,\n.publisher-video-screen .tools {\n  position: absolute !important;\n  bottom: 12px !important;\n  left: 50% !important;\n  transform: translateX(-50%) !important;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.25) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.6) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.6) !important;\n  backdrop-filter: blur(12px) saturate(150%) !important;\n  -webkit-backdrop-filter: blur(12px) saturate(150%) !important;\n  border-radius: 40px !important; /* Elegant pill shape */\n  padding: 6px 12px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15), inset 0 0 0 1px rgba(255, 255, 255, 0.1) !important;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  width: max-content !important;\n  max-width: 96vw !important;\n  min-width: 0 !important;\n}\n\n/* For very small mobile screens */\n@media (max-width: 400px) {\n  .videomode .tools,\n  .publisher-video-screen .tools {\n    max-width: 98vw !important;\n    padding: 4px 8px !important;\n  }\n}\n\n.videomode .tools .middle,\n.publisher-video-screen .tools .middle {\n  display: flex !important;\n  flex-direction: row !important;\n  flex-wrap: nowrap !important; /* Never wrap to multiple rows */\n  gap: 10px !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* Landscape Orientation: Pin toolbar to the right side, stacked vertically */\n@media (orientation: landscape) and (min-width: 900px) {\n  .videomode .tools,\n  .publisher-video-screen .tools {\n    bottom: 50% !important;\n    left: auto !important;\n    right: 16px !important;\n    transform: translateY(50%) !important;\n    padding: 12px 6px !important;\n    max-height: 90vh !important;\n    max-width: max-content !important;\n  }\n  .videomode .tools .middle,\n  .publisher-video-screen .tools .middle {\n    flex-direction: column !important;\n  }\n}\n\n/* 3. Button-Zustände */\n.videomode .tools .button,\n.publisher-video-screen .tools .button {\n  width: 46px !important;\n  height: 46px !important;\n  border-radius: 50% !important;\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: #1e293b !important;\n  border: 1px solid rgba(0, 0, 0, 0.05) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  padding: 0 !important;\n  flex-shrink: 0 !important;\n  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;\n}\n\n.videomode .tools .button i,\n.publisher-video-screen .tools .button i {\n  font-size: 20px !important;\n}\n\n.videomode .tools .button:hover,\n.publisher-video-screen .tools .button:hover {\n  background: rgba(0, 0, 0, 0.1) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.1), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;\n}\n\n.videomode .tools .button:active,\n.publisher-video-screen .tools .button:active {\n  transform: translateY(1px) !important;\n}\n\n/* Mobile specific toolbar sizing */\n@media (max-width: 768px) {\n  .videomode .tools,\n  .publisher-video-screen .tools {\n    bottom: 10px !important;\n    padding: 5px 10px !important;\n  }\n  .videomode .tools .middle,\n  .publisher-video-screen .tools .middle {\n    gap: 8px !important;\n  }\n  .videomode .tools .button,\n  .publisher-video-screen .tools .button {\n    width: 40px !important;\n    height: 40px !important;\n  }\n  .videomode .tools .button i,\n  .publisher-video-screen .tools .button i {\n    font-size: 17px !important;\n  }\n}\n\n/* STATUS MUTED / INACTIVE */\n.videomode .tools .button.status-muted,\n.publisher-video-screen .tools .button.status-muted {\n  background: rgba(239, 68, 68, 0.15) !important;\n  color: #dc2626 !important;\n  border: 1px solid rgba(239, 68, 68, 0.2) !important;\n}\n.videomode .tools .button.status-muted:hover,\n.publisher-video-screen .tools .button.status-muted:hover {\n  background: rgba(239, 68, 68, 0.25) !important;\n}\n\n/* ACTIVE / SELECTED STATES (e.g. Draw Mode, Screen Share, Notes) */\n.videomode .tools .button.active,\n.publisher-video-screen .tools .button.active,\n.videomode .tools .button.btn-notes.active {\n  background: rgba(14, 165, 233, 0.15) !important;\n  color: #0284c7 !important;\n  border: 1px solid rgba(14, 165, 233, 0.3) !important;\n}\n\n/* END CALL BUTTON (Prominentes Rot) */\n.videomode .tools .button.btn-end-call,\n.publisher-video-screen .tools .button.btn-end-call {\n  background: #ef4444 !important;\n  color: #ffffff !important;\n  border: 1px solid rgba(255, 255, 255, 0.4) !important;\n  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;\n}\n.videomode .tools .button.btn-end-call:hover,\n.publisher-video-screen .tools .button.btn-end-call:hover {\n  background: #dc2626 !important;\n  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.4) !important;\n  transform: translateY(-2px) scale(1.05) !important;\n}\n\n/* ───────────────────────────────────────────────────────────── */\n/* MOBILE NOTES & ACTIVITIES OVERLAY / DRAWER                    */\n/* ───────────────────────────────────────────────────────────── */\n\n.mobile-notes-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2000;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n}\n\n.mobile-notes-backdrop {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n}\n\n.mobile-notes-panel {\n  position: relative;\n  z-index: 2001;\n  width: 100%;\n  max-height: 80vh;\n  height: 75vh;\n  background: var(--panel-bg, #1e293b);\n  border-top: 1px solid var(--panel-border, #334155);\n  border-radius: 20px 20px 0 0;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  opacity: 0;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.25s ease;\n  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.mobile-notes-overlay.open {\n  pointer-events: auto;\n}\n\n.mobile-notes-overlay.open .mobile-notes-backdrop {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.mobile-notes-overlay.open .mobile-notes-panel {\n  transform: translateY(0);\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.mobile-notes-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--panel-border, #334155);\n  flex-shrink: 0;\n}\n\n.mobile-notes-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-color, #f8fafc);\n  display: flex;\n  align-items: center;\n}\n\n.mobile-notes-close-btn {\n  background: rgba(255, 255, 255, 0.08);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text-muted, #94a3b8);\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mobile-notes-close-btn:hover {\n  background: rgba(255, 255, 255, 0.16);\n  color: #fff;\n}\n\n.mobile-notes-input-wrapper {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--panel-border, #334155);\n  background: rgba(0, 0, 0, 0.1);\n  flex-shrink: 0;\n}\n\n.mobile-notes-timeline-wrapper {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  padding: 16px;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Floating Action Button (FAB) for mobile when outside of active call */\n.mobile-notes-toggle-fab {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: var(--primary-color, #0284c7);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  cursor: pointer;\n  z-index: 1040;\n  transition: all 0.2s ease;\n}\n\n.mobile-notes-toggle-fab:active {\n  transform: scale(0.95);\n}\n\n@media (min-width: 1101px) {\n  .mobile-notes-overlay,\n  .mobile-notes-toggle-fab {\n    display: none !important;\n  }\n}\n\n/* 4. Status-Meldungen & Overlays - Always at the top of the video screen, highly visible and high contrast */\n.videomode .video-overlay,\n.publisher-video-screen .video-overlay {\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n  right: 0 !important;\n  width: 100% !important;\n  transform: none !important;\n  background: rgba(15, 23, 42, 0.92) !important;\n  backdrop-filter: blur(12px) !important;\n  -webkit-backdrop-filter: blur(12px) !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;\n  border-top: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  color: #fff !important;\n  padding: 12px 24px !important;\n  border-radius: 0 !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  text-align: center !important;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.4) !important;\n  z-index: 99999 !important;\n  white-space: normal !important; /* Allow wrapping if text is long on mobile */\n  pointer-events: none !important;\n}\n\n\n/* ========================================================= */\n/* GLOBAL THEME & ACCESSIBILITY STYLES (NO THEME-DARK REQ)   */\n/* ========================================================= */\n\nbody, #app {\n  background-color: var(--bg-color) !important;\n  background-image: var(--aurora-bg) !important;\n  background-attachment: fixed !important;\n  color: var(--text-color) !important;\n  transition: background-color 0.4s ease, color 0.4s ease, background-image 0.4s ease !important;\n}\n\n/* Typography transitions */\nh1, h2, h3, h4, h5, h6, p, span, div, a {\n  transition: color 0.4s ease, background-color 0.4s ease;\n}\n\n/* Forms Accessibility & Theme */\ninput, textarea, select, .form-control {\n  background-color: var(--input-bg) !important;\n  border: 1px solid var(--input-border) !important;\n  color: var(--input-text) !important;\n  border-radius: 6px !important;\n  transition: all 0.3s ease !important;\n}\n\ninput:focus, textarea:focus, select:focus, .form-control:focus {\n  outline: none !important;\n  border-color: var(--focus-ring) !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2) !important;\n}\n\n/* Glassmorphism for Panels */\n.panel, .card, .video-box, .box, .list-group-item, .well {\n  background: var(--panel-bg) !important;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--panel-border) !important;\n  box-shadow: 0 8px 32px var(--panel-shadow) !important;\n  transition: background-color 0.4s ease, border-color 0.4s ease, box-shadow 0.4s ease !important;\n}\n\n/* Navbar transparency */\n.navbar {\n  background: var(--nav-bg) !important;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid var(--panel-border) !important;\n  transition: background-color 0.4s ease, border-color 0.4s ease !important;\n}\n\n/* Micro-interactions & Gradients for Buttons */\n.btn-primary, .btn-info {\n  background: linear-gradient(135deg, #06b6d4, #26a7df) !important;\n  border: none !important;\n  color: white !important;\n  box-shadow: 0 4px 10px rgba(38, 167, 223, 0.2) !important;\n  transition: all 0.3s ease !important;\n}\n\n.btn-primary:hover, .btn-info:hover {\n  background: linear-gradient(135deg, #0ea5e9, #38bdf8) !important;\n  box-shadow: 0 6px 15px rgba(38, 167, 223, 0.4) !important;\n  transform: translateY(-1px);\n}\n\n.btn-primary:active, .btn-info:active {\n  transform: translateY(1px);\n  box-shadow: 0 2px 5px rgba(38, 167, 223, 0.2) !important;\n}\n\n.new-order-top {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  width: 100% !important;\n}\n\n/* Mobile Sidebar & Accessibility Styles */\n.order-sidebar-toggle-btn {\n  display: none; /* hidden by default on desktop */\n  background: none;\n  border: 1px solid var(--panel-border);\n  border-radius: 8px;\n  color: var(--text-color);\n  padding: 6px 10px;\n  cursor: pointer;\n  font-size: 16px;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n\n.order-sidebar-mobile-close {\n  display: none;\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  font-size: 24px;\n  color: var(--text-color);\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 10000;\n}\n\n\n\n/* Resizer */\n.column-resizer:hover {\n  background-color: rgba(100, 100, 100, 0.2);\n}\n.column-resizer:active {\n  background-color: rgba(100, 100, 100, 0.4);\n}\n\n/* Info Tooltip */\n.info-tooltip {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  font-size: 11px;\n  font-weight: bold;\n  cursor: help;\n  margin-left: 8px;\n  vertical-align: middle;\n}\n\n.info-tooltip::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(4px);\n  background: var(--primary-color);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: normal;\n  white-space: normal;\n  width: max-content;\n  max-width: 300px;\n  text-align: left; /* Bei längeren Texten liest sich linksbündig besser */\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s, transform 0.2s;\n  pointer-events: none;\n  z-index: 9999;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n}\n\n.info-tooltip::before {\n  content: '';\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-2px);\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent var(--primary-color) transparent;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.2s, transform 0.2s;\n  pointer-events: none;\n  z-index: 9999;\n}\n\n.info-tooltip:hover::after,\n.info-tooltip:hover::before {\n  opacity: 1;\n  visibility: visible;\n  transform: translateX(-50%) translateY(8px);\n}\n.info-tooltip:hover::before {\n  transform: translateX(-50%) translateY(2px);\n}\n\n/* ---------------------------------------------------\n * Offline/Online Badge Modernization\n * --------------------------------------------------- */\n.offline-ui {\n  position: absolute !important;\n  bottom: 24px !important;\n  left: 24px !important;\n  top: auto !important;\n  right: auto !important;\n  z-index: 100 !important;\n  border-radius: var(--radius-pill) !important;\n  font-family: Arial, \"Helvetica Neue\", Helvetica, sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  letter-spacing: 0.1px !important;\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-start !important;\n  gap: 4px !important;\n  padding: 7px 14px !important;\n  cursor: default !important;\n  transition: box-shadow 0.3s ease, background 0.3s ease !important;\n}\n\n/* Dark mode (default): Apple Liquid Glass */\n.offline-ui {\n  background: rgba(15, 23, 42, 0.35) !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.25) !important;\n  color: #f1f5f9 !important;\n  box-shadow:\n    0 0 0 1px rgba(255,255,255,0.06),\n    0 0 18px 4px rgba(255,255,255,0.08),\n    0 8px 24px rgba(0,0,0,0.3) !important;\n  backdrop-filter: blur(20px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;\n}\n.offline-ui.offline-ui-up {\n  box-shadow:\n    0 0 0 1px rgba(74, 222, 128, 0.2),\n    0 0 22px 6px rgba(74, 222, 128, 0.25),\n    0 4px 12px rgba(0,0,0,0.4) !important;\n}\n.offline-ui.offline-ui-down {\n  box-shadow:\n    0 0 0 1px rgba(239, 68, 68, 0.25),\n    0 0 22px 6px rgba(239, 68, 68, 0.3),\n    0 4px 12px rgba(0,0,0,0.4) !important;\n}\n\n/* Hide legacy dot and fix spacing */\n.offline-ui-content::after {\n  display: none !important;\n}\n.offline-ui-content {\n  padding-left: 0 !important;\n}\n\n/* Dot indicator */\n.offline-indicator-dot {\n  display: inline-block !important;\n  width: 8px !important;\n  height: 8px !important;\n  border-radius: 50% !important;\n  flex-shrink: 0 !important;\n}\n.offline-ui-up .offline-indicator-dot {\n  background: #4ade80 !important;\n  box-shadow: 0 0 6px rgba(74, 222, 128, 0.8) !important;\n  animation: pulse-green 2s infinite !important;\n}\n.offline-ui-down .offline-indicator-dot {\n  background: #ef4444 !important;\n  box-shadow: 0 0 6px rgba(239, 68, 68, 0.8) !important;\n}\n\n@keyframes pulse-green {\n  0%, 100% { box-shadow: 0 0 4px rgba(74, 222, 128, 0.6); }\n  50%       { box-shadow: 0 0 12px rgba(74, 222, 128, 1); }\n}\n\n/* Light mode: Apple Liquid Glass */\nhtml[data-theme=\"light\"] .offline-ui {\n  background: rgba(255, 255, 255, 0.25) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.6) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.6) !important;\n  color: #1e293b !important;\n  box-shadow:\n    0 8px 32px rgba(0, 0, 0, 0.15),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.1) !important;\n  backdrop-filter: blur(12px) saturate(150%) !important;\n  -webkit-backdrop-filter: blur(12px) saturate(150%) !important;\n}\nhtml[data-theme=\"light\"] .offline-ui.offline-ui-up {\n  box-shadow:\n    0 0 0 1px rgba(21, 128, 61, 0.2),\n    0 0 20px 5px rgba(21, 128, 61, 0.2),\n    0 4px 12px rgba(15,23,42,0.12) !important;\n}\nhtml[data-theme=\"light\"] .offline-ui.offline-ui-down {\n  box-shadow:\n    0 0 0 1px rgba(185, 28, 28, 0.2),\n    0 0 20px 5px rgba(185, 28, 28, 0.2),\n    0 4px 12px rgba(15,23,42,0.12) !important;\n}\nhtml[data-theme=\"light\"] .offline-ui.offline-ui-up::before {\n  background: #16a34a !important;\n  box-shadow: 0 0 6px rgba(21, 128, 61, 0.7) !important;\n}\n\n/* ---------------------------------------------------\n * Publisher Video Screen: always dark background\n * regardless of light/dark mode (you're in a video call!)\n * --------------------------------------------------- */\n.publisher-video-screen,\n.publisher-video-screen .video,\n.publisher-video-screen .videomode {\n  background: #000 !important;\n}\n\n/* Always use dark mode style for offline/online badges on video screens */\n.publisher-video-screen .offline-ui,\n.videomode .offline-ui,\nhtml[data-theme=\"light\"] .publisher-video-screen .offline-ui,\nhtml[data-theme=\"light\"] .videomode .offline-ui {\n  background: rgba(15, 23, 42, 0.45) !important;\n  border: 1px solid rgba(255, 255, 255, 0.15) !important;\n  border-top: 1px solid rgba(255, 255, 255, 0.25) !important;\n  color: #f8fafc !important;\n  box-shadow:\n    0 0 0 1px rgba(255,255,255,0.06),\n    0 0 18px 4px rgba(255,255,255,0.08),\n    0 8px 24px rgba(0,0,0,0.3) !important;\n  backdrop-filter: blur(20px) saturate(180%) !important;\n  -webkit-backdrop-filter: blur(20px) saturate(180%) !important;\n}\n\n.publisher-video-screen .offline-ui.offline-ui-up,\n.videomode .offline-ui.offline-ui-up,\nhtml[data-theme=\"light\"] .publisher-video-screen .offline-ui.offline-ui-up,\nhtml[data-theme=\"light\"] .videomode .offline-ui.offline-ui-up {\n  box-shadow:\n    0 0 0 1px rgba(74, 222, 128, 0.2),\n    0 0 22px 6px rgba(74, 222, 128, 0.25),\n    0 10px 30px rgba(0,0,0,0.45) !important;\n}\n\n.publisher-video-screen .offline-ui.offline-ui-down,\n.videomode .offline-ui.offline-ui-down,\nhtml[data-theme=\"light\"] .publisher-video-screen .offline-ui.offline-ui-down,\nhtml[data-theme=\"light\"] .videomode .offline-ui.offline-ui-down {\n  box-shadow:\n    0 0 0 1px rgba(239, 68, 68, 0.25),\n    0 0 22px 6px rgba(239, 68, 68, 0.25),\n    0 10px 30px rgba(0,0,0,0.45) !important;\n}\n\n.publisher-video-screen .offline-ui.offline-ui-up::before,\n.videomode .offline-ui.offline-ui-up::before,\nhtml[data-theme=\"light\"] .publisher-video-screen .offline-ui.offline-ui-up::before,\nhtml[data-theme=\"light\"] .videomode .offline-ui.offline-ui-up::before {\n  background: #22c55e !important;\n  box-shadow: 0 0 8px rgba(34, 197, 94, 0.8) !important;\n}\n\n.publisher-video-screen .offline-ui.offline-ui-down::before,\n.videomode .offline-ui.offline-ui-down::before,\nhtml[data-theme=\"light\"] .publisher-video-screen .offline-ui.offline-ui-down::before,\nhtml[data-theme=\"light\"] .videomode .offline-ui.offline-ui-down::before {\n  background: #ef4444 !important;\n  box-shadow: 0 0 8px rgba(239, 68, 68, 0.8) !important;\n}\n\n/* ---------------------------------------------------\n * OpenTok: force subscriber/publisher to fill container\n * --------------------------------------------------- */\n#opentok-container .OT_subscriber,\n#opentok-container .OT_publisher {\n  width: 100% !important;\n  height: 100% !important;\n  position: absolute !important;\n  top: 0 !important;\n  left: 0 !important;\n}\n\n/* Make opentok-container itself use relative/absolute layout */\n.publisher-video-screen #opentok-container {\n  position: relative !important;\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n  background: #000 !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.OT_subscriber .OT_widget-container,\n.OT_publisher .OT_widget-container {\n  width: 100% !important;\n  height: 100% !important;\n  background: #000 !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.OT_subscriber video,\n.OT_publisher video {\n  width: 100% !important;\n  height: 100% !important;\n  object-fit: contain !important;\n  object-position: center !important;\n  background: #000 !important; /* Black letterbox bars when aspect ratio doesn't match */\n}\n\n/* Hide OpenTok's irritating default \"camera crossed out\" icon that flashes during initialization */\n.OT_video-poster,\n.OT_publisher .OT_video-poster,\n.OT_subscriber .OT_video-poster {\n  display: none !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n  background-image: none !important;\n  background-color: transparent !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n/* Also hide any default OpenTok UI overlays that might flash */\n.OT_edge-bar-item.OT_mute,\n.OT_audio-only-icon,\n.OT_video-poster svg,\n.OT_audio-only-icon svg,\n.OT_root svg {\n  display: none !important;\n  opacity: 0 !important;\n  visibility: hidden !important;\n  width: 0 !important;\n  height: 0 !important;\n}\n\n/* Video Paused Pill (Liquid Glass) */\n.video-state-pill {\n  background: rgba(0, 0, 0, 0.5);\n  color: #ffffff;\n  padding: 16px 32px;\n  border-radius: 20px;\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  transition: all 0.3s ease;\n}\n\n.video-state-pill-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.video-state-pill-subtitle {\n  font-size: 14px;\n  opacity: 0.9;\n  font-weight: 400;\n  max-width: 280px;\n  line-height: 1.4;\n}\n\n/* Agent Toolbar Icons (Black for better contrast) */\n.video-chat-embedded .tools .button i {\n  color: #000000 !important;\n}\n.video-chat-embedded .tools .button.btn-end-call i {\n  color: #ffffff !important;\n}\n\n/* End Call Modal Contrast Fixes */\n.lh-modal .call-end-modal-note-is-ended,\n.lh-modal .call-end-modal-duration-title,\n.lh-modal .call-end-modal-end-note {\n  color: var(--text-secondary) !important;\n}\n\n.lh-modal .call-end-modal-duration-value {\n  color: var(--text-primary) !important;\n}\n\n/* Modal Input Fields */\n.lh-modal textarea,\n.lh-modal select {\n  background-color: #ffffff !important;\n  color: #1e293b !important;\n  border: 1px solid #e2e8f0 !important;\n  border-radius: 8px !important;\n  padding: 12px !important;\n  font-family: inherit !important;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.05) !important;\n}\n\n.lh-modal select {\n  padding-right: 32px !important; /* Make room for the dropdown arrow */\n}\n\n/* ========================================================= */\n/* RESPONSIVE ANONYMOUS LAYOUT (LOGIN, RESET PASSWORD, ETC.) */\n/* ========================================================= */\n\n.anonymous-container {\n  min-height: 100vh;\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  background: var(--bg-color);\n}\n\n.anonymous-card-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.anonymous-card {\n  background-color: var(--panel-bg);\n  border-radius: 32px;\n  box-shadow: var(--glass-shadow);\n  border: 1px solid var(--panel-border);\n  overflow: hidden;\n}\n\n.anonymous-header {\n  position: relative;\n  padding: 32px 0;\n  border-bottom: 1px solid var(--panel-border);\n  background-color: var(--panel-bg);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.anonymous-theme-toggle {\n  position: absolute;\n  right: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n}\n\n.login-section-left {\n  flex: 1 1 400px;\n  padding: 48px;\n  border-right: 1px solid var(--panel-border);\n}\n\n.login-section-right {\n  flex: 1 1 400px;\n  padding: 48px;\n}\n\n.login-icon {\n  width: 56px;\n  height: 56px;\n  object-fit: contain;\n  transition: display 0.2s ease;\n}\n\n@media (max-width: 767px) {\n  .anonymous-container {\n    padding: 16px !important;\n    justify-content: flex-start !important;\n  }\n  .anonymous-card-wrapper {\n    margin-top: 16px !important;\n  }\n  .anonymous-card {\n    border-radius: 20px !important;\n  }\n  .anonymous-header {\n    padding: 20px 0 !important;\n  }\n  .anonymous-theme-toggle {\n    right: 16px !important;\n  }\n  .login-section-left,\n  .login-section-right {\n    padding: 24px !important;\n  }\n  .login-section-left {\n    border-right: none !important;\n    border-bottom: 1px solid var(--panel-border) !important;\n  }\n}\n\n@media (max-width: 500px) {\n  .login-icon {\n    display: none !important;\n  }\n}\n\n/* Responsive table utility for mobile and small screens */\n.responsive-table td .avatar {\n  width: 36px !important;\n  height: 36px !important;\n  line-height: 36px !important;\n  font-size: 14px !important;\n  border-radius: 50% !important;\n  box-shadow: none !important;\n}\n\n@media (max-width: 768px) {\n  /* Mobile Layout Fallbacks */\n  table.responsive-table,\n  table.responsive-table > tbody,\n  table.responsive-table > tbody > tr,\n  table.responsive-table > tbody > tr > td {\n    display: block !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  /* Show table header as a sorting control bar of buttons on mobile */\n  table.responsive-table > thead {\n    display: block !important;\n    margin-bottom: 16px !important;\n    width: 100% !important;\n  }\n  table.responsive-table > thead > tr {\n    display: flex !important;\n    gap: 12px !important;\n    background: transparent !important;\n    border: none !important;\n    padding: 0 !important;\n    width: 100% !important;\n    box-shadow: none !important;\n  }\n  table.responsive-table > thead > tr > th {\n    display: inline-flex !important;\n    flex: 1 !important;\n    justify-content: center !important;\n    align-items: center !important;\n    background: var(--btn-default-bg) !important;\n    border: 1px solid var(--btn-default-border) !important;\n    border-radius: 8px !important;\n    padding: 10px 12px !important;\n    font-size: 11px !important;\n    color: var(--text-muted) !important;\n    text-transform: uppercase !important;\n    font-weight: bold !important;\n    letter-spacing: 0.05em !important;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;\n    text-align: center !important;\n    cursor: pointer !important;\n    user-select: none !important;\n    min-width: auto !important;\n    max-width: none !important;\n    width: auto !important;\n    white-space: nowrap !important;\n    text-overflow: ellipsis !important;\n    overflow: hidden !important;\n  }\n  table.responsive-table > thead > tr > th:last-child {\n    display: none !important; /* Hide actions header column */\n  }\n\n  /* Table Row Card layout using relative positioning */\n  table.responsive-table > tbody > tr {\n    display: block !important;\n    position: relative !important;\n    margin-bottom: 16px !important;\n    background: var(--panel-bg) !important;\n    border: 1px solid var(--panel-border) !important;\n    border-radius: 12px !important;\n    padding: 16px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;\n  }\n  table.responsive-table > tbody > tr > td {\n    padding: 8px 0 !important;\n    border: none !important;\n    white-space: normal !important;\n    word-break: break-word !important;\n    min-width: auto !important;\n    max-width: none !important;\n    width: auto !important;\n  }\n  \n  /* Customer / User Info Cell (1st cell) aligned left, padded on right for actions */\n  table.responsive-table > tbody > tr > td:first-child {\n    display: block !important;\n    padding-right: 170px !important;\n    width: auto !important;\n  }\n\n  /* Actions Cell (last cell) absolute positioned top right */\n  table.responsive-table > tbody > tr > td:last-child {\n    position: absolute !important;\n    top: 20px !important;\n    right: 16px !important;\n    width: auto !important;\n    padding: 0 !important;\n    display: block !important;\n  }\n  table.responsive-table > tbody > tr > td:last-child > div {\n    display: flex !important;\n    justify-content: flex-end !important;\n    gap: 8px !important;\n  }\n  \n  /* Separate the header row (1st cell) from the details below with border */\n  table.responsive-table > tbody > tr > td:nth-child(2) {\n    display: block !important;\n    border-top: 1px solid var(--panel-border) !important;\n    padding-top: 12px !important;\n    margin-top: 8px !important;\n    width: 100% !important;\n  }\n  table.responsive-table > tbody > tr > td:nth-child(3) {\n    display: block !important;\n    width: 100% !important;\n  }\n\n  /* Last Event Cell Layout (label on top, date below, text below that, all aligned left) */\n  table.responsive-table > tbody > tr > td.last-event-cell::before {\n    content: attr(data-label);\n    font-weight: bold;\n    color: var(--text-muted);\n    display: block !important;\n    margin-bottom: 6px !important;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  table.responsive-table > tbody > tr > td.last-event-cell .last-event-date {\n    font-size: 13px !important;\n    font-weight: bold !important;\n    color: var(--text-color) !important;\n    display: block !important;\n    text-align: left !important;\n  }\n  table.responsive-table > tbody > tr > td.last-event-cell .last-event-text {\n    margin-top: 4px !important;\n    font-size: 13px !important;\n    color: var(--text-muted) !important;\n    display: block !important;\n    text-align: left !important;\n  }\n\n  /* General fallback label block layout for non-event columns (e.g. Roles/Email) */\n  table.responsive-table > tbody > tr > td[data-label]:not(.last-event-cell)::before {\n    content: attr(data-label);\n    font-weight: bold;\n    color: var(--text-muted);\n    display: block !important;\n    margin-bottom: 6px;\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  table.responsive-table .column-resizer {\n    display: none !important;\n  }\n}\n\n/* Streamlined Dropdown Menu Styling */\n.dropdown-menu {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif !important;\n  font-size: 13px !important;\n  border-radius: 8px !important;\n  border: 1px solid var(--panel-border) !important;\n  background-color: var(--dropdown-bg) !important;\n  box-shadow: var(--shadow-md) !important;\n  padding: 6px 0 !important;\n  z-index: 1050 !important;\n}\n\n.dropdown-menu > li > a {\n  color: var(--text-color) !important;\n  padding: 8px 16px !important;\n  font-family: inherit !important;\n  font-size: inherit !important;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  background-color: var(--surface-3) !important;\n  color: var(--primary-color) !important;\n  text-decoration: none !important;\n}\n\n.dropdown-menu > .dropdown-header {\n  font-family: inherit !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.05em !important;\n  color: var(--text-muted) !important;\n  padding: 6px 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
